<template>
  <div class="knowledge-page knowledge-client flex-col">
      <div v-if="!hideViewModeBar" class="knowledge-view-switch-bar">
        <div class="knowledge-view-switch" role="tablist">
          <button
            type="button"
            class="knowledge-view-switch-btn"
            :class="{ active: resolvedLibraryViewMode === 'all' }"
            @click="setLibraryViewMode('all')"
          >全部</button>
          <button
            type="button"
            class="knowledge-view-switch-btn"
            :class="{ active: resolvedLibraryViewMode === 'edit' }"
            @click="setLibraryViewMode('edit')"
          >编辑</button>
        </div>
      </div>
      <div class="knowledge-main-row">
      <div class="knowledge-left-panel flex-col align-stretch" style="flex-shrink:0;width:300px;flex-grow:1;">
        <div class="directory-panel-search">
          <Input
            v-model="dirSearchText"
            search
            clearable
            placeholder="搜索目录"
            class="directory-search-input"
          />
          <div class="directory-view-filters">
            <button
              v-for="opt in dirViewFilterOptions"
              :key="'dir-view-'+opt.value"
              type="button"
              class="directory-view-filter-btn"
              :class="{ active: dirViewFilter === opt.value }"
              :title="opt.label"
              @click="dirViewFilter = opt.value"
            >
              <BaseIcon v-if="opt.icon" :icon="opt.icon" :size="14" />
              <span class="directory-view-filter-short">{{ opt.short }}</span>
            </button>
          </div>
        </div>
        <div class="directory-panel-header">
          <span class="directory-panel-title">目录</span>
          <div class="directory-panel-toolbar">
            <button
              type="button"
              class="directory-config-btn"
              title="全部展开"
              @click="handleDirTreeExpandAll"
            >
              <BaseIcon icon="md-expand" :size="16" />
            </button>
            <button
              type="button"
              class="directory-config-btn"
              title="全部折叠"
              @click="handleDirTreeCollapseAll"
            >
              <BaseIcon icon="md-contract" :size="16" />
            </button>
            <Toolbar :items="directoryTools" v-model="toolBarValue" @on-event="handleDirectoryToolbarEvent" />
            <button
              v-if="selectedDir"
              type="button"
              class="directory-config-btn"
              title="预览"
              @click="handleDirPreview(selectedDir)"
            >
              <BaseIcon icon="md-eye" :size="16" />
            </button>
          </div>
        </div>
        <KnowledgeDirectory
          :dirs="displayDirectories"
          :selected-dir="selectedDir"
          :expand-token="dirTreeExpandToken"
          :session="session"
          :knowledge-auth="knowledgeAuth"
          style="flex-grow:1"
          @on-select="handleDirSelect"
          @on-drop-in="handleDirDropIn"
          @on-drop-file="handleFileDropToDir"
          @on-config="handleDirConfig"
          @on-context-action="handleDirContextAction"
          @on-load-ref="handleRefDirectoryLoad"
        ></KnowledgeDirectory>
      </div>
       
        <div class="flex-col align-stretch" style="flex-grow:1;width:calc(100% - 300px);">
          <div class="data-panel-header">
            <Input
              v-model="searchText"
              search
              placeholder="搜索内容"
              clearable
              class="data-search-input"
            />
            <input
              ref="dataFileInput"
              type="file"
              multiple
              :accept="uploadAccept || undefined"
              style="display:none"
              @change="handleDataFileInputChange"
            />
            <Toolbar :items="dataTools" v-model="toolBarValue" @on-event="handleDataToolbarEvent" @input="handleToolbarInput" class="data-panel-toolbar"/>
          </div>
          <KnowledgeList
          style="flex-grow:1"
          :loading="loading"
          :items="filteredItems"
          :subdirs="selectedSubdirs"
          :all-items="allItems"
          :all-directories="allDirectories"
          :ref-display-context="isSelectedRefContext"
          :ref-list-parent-id="selectedContentDirId"
          :view-mode="viewMode"
          :dir-editable="selectedDirEditable"
          :can-upload="canUploadFiles"
          :upload-accept="uploadAccept"
          :empty-upload-label="emptyUploadLabel"
          :dir-selected="!!selectedDir"
          @on-drop-in-folder="handleItemDropInFolder"
          @on-drop-in-dir="handleFileDropToDir"
          @on-select="handleItemSelect"
          @on-open="handleItemOpen"
          @on-edit="handleItemEdit"
          @on-file-drop="handleFileDrop"
          @on-dir-select="handleDirSelect"
          @on-context-menu="handleItemContextMenu"
          @on-markdown="handleItemMarkdown"
        ></KnowledgeList>
        </div>

      </div>
        <div class="knowledge-status-bar">
          <span class="status-path">
            <template v-if="!selectedDir">未选中</template>
            <template v-else>
              <span
                v-for="(dir, idx) in selectedDirPathArray"
                :key="getDirectoryVueKey(dir, { parentId: selectedDir && selectedDir.id })"
                class="status-path-item"
              >
                <span v-if="idx > 0" class="status-path-sep"><BaseIcon icon="ios-arrow-forward" :size="12" /></span>
                <span class="status-path-link" @click="handleDirSelect(dir)">{{ dir.name }}</span>
              </span>
            </template>
          </span>
          <span class="status-meta">
            <span class="status-count">{{ selectedDir ? filteredItems.length : 0 }} 个文件</span>
            <span class="status-usage">128 MB / 1 GB</span>
            <span v-if="selectedDir" class="status-dir-meta">
              <span class="status-dir-meta-item">
                <span class="status-dir-meta-label">目录类型</span>
                <span class="status-dir-meta-value">{{ selectedDirTypeLabel }}</span>
              </span>
              <span v-if="selectedDirDataTypeLabel" class="status-dir-meta-item">
                <span class="status-dir-meta-label">数据类型</span>
                <span class="status-dir-meta-value">{{ selectedDirDataTypeLabel }}</span>
              </span>
            </span>
            <span v-if="selectedDirOwnerId" class="status-charger">
              <span class="status-charger-label">目录所有者</span>
              <BaseNameBoard :uid="selectedDirOwnerId" :size="18" />
            </span>
            <span v-if="knowledgeRoleText" class="status-role">
              <span class="status-role-label">当前角色</span>
              <span class="status-role-value">{{ knowledgeRoleText }}</span>
            </span>
          </span>
        </div>

        <Drawer
          v-model="showDetail"
          :width="800"
          class-name="knowledge-detail-drawer"
          :styles="{ padding: 0 }"
        >
          <KnowledgeDetail :current="current" :all-items="allItems" />
        </Drawer>

        <!-- 目录编辑 / 配置对话框 -->
        <Modal
          v-model="showDirPermission"
          footer-hide
          :mask-closable="false"
          width="920"
          class-name="knowledge-dir-config-modal"
        >
          <div slot="header" class="dir-config-header">
            <div class="dir-config-header-icon">
              <BaseIcon
                :icon="isConfigRemoteDir ? 'md-cloud' : (isConfigRefDir ? 'lianjie' : 'md-folder')"
                :size="22"
              />
            </div>
            <div class="dir-config-header-main">
              <div class="dir-config-title">{{ dirModalTitle }}</div>
              <div class="dir-config-subtitle" v-if="permissionForm.name">{{ permissionForm.name }}</div>
              <div class="dir-config-subtitle" v-else-if="permissionForm.parent_id">在选中目录下新建</div>
            </div>
          </div>

          <div class="dir-config-body" :class="{ 'dir-config-body--readonly': dirModalReadOnly }">
            <Alert
              v-if="dirModalReadOnly && permissionViewRefSource"
              show-icon
              type="info"
              class="dir-config-remote-tip"
            >
              引用目录「{{ permissionRefDir && permissionRefDir.name }}」的配置与权限由源目录接管，此处仅可查看不可修改。
            </Alert>
            <Alert
              v-else-if="dirModalReadOnly"
              show-icon
              type="info"
              class="dir-config-remote-tip"
            >
              当前目录通过引用展示，配置与权限仅可查看不可修改。
            </Alert>
            <div class="dir-config-section">
              <div class="dir-config-section-title">基础设置</div>
              <div class="dir-config-card dir-config-card--compact">
                <div class="dir-config-field">
                  <label class="dir-config-label">目录名称</label>
                  <Input v-model="permissionForm.name" placeholder="请输入目录名称" :maxlength="50" :disabled="dirModalReadOnly" />
                </div>

                <div class="dir-config-field">
                  <label class="dir-config-label">目录类型</label>
                  <div v-if="permissionForm.id || isPermissionUnderDocumentDir" class="dir-config-readonly-value">
                    {{ configDirTypeLabel }}
                  </div>
                  <RadioGroup
                    v-else
                    v-model="permissionForm.type"
                    class="dir-type-btn-group"
                    @on-change="handleConfigTypeChange"
                  >
                    <Radio
                      v-for="opt in dirTypeButtonOptions"
                      :key="opt.value"
                      :label="opt.value"
                      class="dir-type-btn"
                    >
                      <BaseIcon :icon="opt.icon" :size="16" />
                      <span>{{ opt.label }}</span>
                    </Radio>
                  </RadioGroup>
                </div>

                <div class="dir-config-field" v-if="isConfigRemoteDir">
                  <label class="dir-config-label">远程访问地址</label>
                  <Input v-model="permissionForm.remote_api" placeholder="请输入远程 API 地址，如 https://api.example.com/knowledge" :disabled="dirModalReadOnly" />
                </div>

                <div class="dir-config-field" v-if="isConfigLocalDir">
                  <label class="dir-config-label">数据类型</label>
                  <div v-if="permissionForm.id || dirDataTypeLocked" class="dir-config-readonly-value dir-config-readonly-value--with-icon">
                    <BaseIcon
                      v-if="configDirDataTypeIcon"
                      :icon="configDirDataTypeIcon"
                      :size="16"
                      class="dir-config-readonly-icon"
                    />
                    <span>{{ configDirDataTypeLabel }}</span>
                  </div>
                  <RadioGroup v-else v-model="permissionForm.data_type" class="dir-type-btn-group dir-data-type-btn-group">
                    <Radio
                      v-for="opt in allowedDirDataTypes"
                      :key="opt.value"
                      :label="opt.value"
                      class="dir-type-btn dir-data-type-btn"
                    >
                      <BaseIcon v-if="opt.icon" :icon="opt.icon" :size="16" />
                      <div class="dir-data-type-text">
                        <span class="dir-data-type-label">{{ opt.label }}</span>
                        <span class="dir-data-type-desc">{{ opt.desc }}</span>
                      </div>
                    </Radio>
                  </RadioGroup>
                </div>

                <div class="dir-config-field" v-if="isConfigRefDir">
                  <label class="dir-config-label">引用目录</label>
                  <Select v-model="permissionForm.remote_api" filterable clearable transfer placeholder="选择引用的目录（非系统目录）" :disabled="dirModalReadOnly">
                    <Option
                      v-for="dir in refDirectoryOptions"
                      :key="'cfg-ref-'+dir.id"
                      :value="String(dir.id)"
                    >{{ dir.name }}</Option>
                  </Select>
                </div>

                <div class="dir-config-field">
                  <label class="dir-config-label">描述</label>
                  <Input
                    v-model="permissionForm.description"
                    type="textarea"
                    :rows="2"
                    placeholder="请输入目录描述（最多128字）"
                    :maxlength="128"
                    show-word-limit
                    :disabled="dirModalReadOnly"
                  />
                </div>

                <div class="dir-config-field" v-if="permissionForm.id">
                  <label class="dir-config-label">目录所有者</label>
                  <BaseUserSelectGrouped
                    v-model="permissionForm.owner_id"
                    placeholder="选择目录所有者"
                    :disabled="dirModalReadOnly"
                  />
                </div>

                <div class="dir-config-switch-grid dir-config-switch-grid--compact">
                  <div class="dir-config-switch-item" v-if="!isConfigRemoteDir">
                    <div class="dir-config-switch-meta">
                      <span class="dir-config-switch-name">允许编辑内容</span>
                      <span class="dir-config-switch-desc">关闭后只读</span>
                    </div>
                    <i-switch v-model="permissionForm.editable" size="small" :disabled="dirModalReadOnly" />
                  </div>
                  <div class="dir-config-switch-item" v-if="!isConfigRemoteDir">
                    <div class="dir-config-switch-meta">
                      <span class="dir-config-switch-name">启用审批</span>
                      <span class="dir-config-switch-desc">变更需审批</span>
                    </div>
                    <i-switch v-model="permissionForm.enable_approval" size="small" :disabled="dirModalReadOnly" />
                  </div>
                  <div class="dir-config-switch-item">
                    <div class="dir-config-switch-meta">
                      <span class="dir-config-switch-name">允许创建子目录</span>
                      <span class="dir-config-switch-desc">关闭后不可新建</span>
                    </div>
                    <i-switch v-model="permissionForm.enable_create_sub" size="small" :disabled="dirModalReadOnly" />
                  </div>
                  <div class="dir-config-switch-item" v-if="!isConfigRemoteDir && !isConfigRefDir">
                    <div class="dir-config-switch-meta">
                      <span class="dir-config-switch-name">允许上传文件</span>
                      <span class="dir-config-switch-desc">关闭后不可上传或新建文件</span>
                    </div>
                    <i-switch v-model="permissionForm.enable_upload" size="small" :disabled="dirModalReadOnly" />
                  </div>
                </div>

                <Alert v-if="isConfigRemoteDir" show-icon type="warning" class="dir-config-remote-tip">
                  远程目录通过 API 提供数据，不允许上传或修改文件。
                </Alert>
                <Alert v-if="isConfigRefDir" show-icon type="info" class="dir-config-remote-tip">
                  引用目录仅创建指向，展示源目录内容；删除引用不会影响源目录及其文件。
                </Alert>
                <Alert v-if="isConfigLocalDir && permissionForm.data_type === 'parsed'" show-icon type="info" class="dir-config-remote-tip">
                  文档目录仅支持 Markdown 文件；其子目录也只能是文档目录。
                </Alert>
              </div>
            </div>

            <div class="dir-config-section">
              <div class="dir-config-section-head">
                <div>
                  <div class="dir-config-section-title">访问控制</div>
                  <div class="dir-config-section-desc">配置目录公开范围及用户 / 群组 / 角色权限；管理员与目录所有者拥有全部权限</div>
                </div>
                <Button
                  v-if="permissionForm.id && !dirModalReadOnly"
                  type="primary"
                  size="small"
                  icon="md-add"
                  class="dir-config-add-perm-btn"
                  @click="handleAddPermissionRow"
                >添加授权</Button>
              </div>

              <div class="dir-config-switch-grid dir-config-access-vis">
                <div class="dir-config-switch-item">
                  <div class="dir-config-switch-meta">
                    <span class="dir-config-switch-name">外部公开</span>
                    <span class="dir-config-switch-desc">未登录用户可访问</span>
                  </div>
                  <i-switch v-model="permissionForm.is_shared" size="small" :disabled="dirModalReadOnly" />
                </div>
                <div class="dir-config-switch-item">
                  <div class="dir-config-switch-meta">
                    <span class="dir-config-switch-name">内部公开</span>
                    <span class="dir-config-switch-desc">组织内所有用户可访问</span>
                  </div>
                  <i-switch v-model="permissionInternalPublic" size="small" :disabled="dirModalReadOnly" />
                </div>
              </div>

              <div class="dir-config-perm-add" v-if="permissionForm.id && showPermAddForm && !dirModalReadOnly">
                <div class="dir-config-perm-add-row">
                  <Select v-model="permAddForm.client_type" style="width:100px;" transfer @on-change="handlePermClientTypeChange">
                    <Option value="user">用户</Option>
                    <Option value="group">群组</Option>
                    <Option value="role">角色</Option>
                  </Select>
                  <BaseUserSelectGrouped
                    v-if="permAddForm.client_type === 'user'"
                    v-model="permAddForm.client_id"
                    placeholder="选择用户"
                    style="flex:1;min-width:180px;"
                  />
                  <Select
                    v-else-if="permAddForm.client_type === 'group'"
                    v-model="permAddForm.client_id"
                    filterable
                    clearable
                    placeholder="选择群组"
                    style="flex:1;min-width:180px;"
                    transfer
                  >
                    <Option v-for="group in aclGroupOptions" :key="'acl-group-'+group.id" :value="String(group.id)">{{ group.name }}</Option>
                  </Select>
                  <Select
                    v-else
                    v-model="permAddForm.client_id"
                    filterable
                    clearable
                    placeholder="选择角色"
                    style="flex:1;min-width:180px;"
                    transfer
                  >
                    <Option v-for="role in aclRoles" :key="'acl-role-'+role.id" :value="String(role.id)">{{ role.name }}</Option>
                  </Select>
                </div>
                <div class="dir-config-perm-add-row dir-config-perm-flags">
                  <Select v-model="permAddForm.mod" style="width:100px;" transfer>
                    <Option value="view">可见</Option>
                    <Option value="edit">可编辑</Option>
                  </Select>
                  <RadioGroup v-model="permAddForm.effect" type="button" size="small">
                    <Radio label="allow">允许</Radio>
                    <Radio label="deny">禁止</Radio>
                  </RadioGroup>
                  <div class="dir-config-perm-add-actions">
                    <Button size="small" @click="cancelPermAddForm">取消</Button>
                    <Button type="primary" size="small" :loading="aclSaving" @click="confirmPermAddForm">确认</Button>
                  </div>
                </div>
              </div>

              <div class="dir-config-perm-table-wrap" v-if="permissionForm.id">
                <table class="dir-config-perm-table" v-if="permissionForm.permissions.length">
                  <thead>
                    <tr>
                      <th>类型</th>
                      <th>授权对象</th>
                      <th class="perm-mod-col">权限</th>
                      <th class="perm-effect-col">策略</th>
                      <th class="perm-action-col" v-if="!dirModalReadOnly">操作</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in permissionForm.permissions" :key="aclRowKey(row, index)">
                      <td>
                        <Tag :color="aclClientTypeColor(row.client_type)">{{ aclClientTypeLabel(row.client_type) }}</Tag>
                      </td>
                      <td>{{ resolveAclClientName(row) }}</td>
                      <td class="perm-mod-col">
                        <Tag :color="row.mod === 'edit' ? 'blue' : 'default'">{{ row.mod === 'edit' ? '可编辑' : '可见' }}</Tag>
                      </td>
                      <td class="perm-effect-col">
                        <Tag :color="row.denied ? 'error' : 'success'">{{ row.denied ? '禁止' : '允许' }}</Tag>
                      </td>
                      <td class="perm-action-col" v-if="!dirModalReadOnly">
                        <Button type="text" size="small" class="perm-remove-btn" :loading="aclSaving" @click="removePermissionRow(row)">删除</Button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div v-else class="dir-config-perm-empty">暂无授权，点击「添加授权」配置用户 / 群组 / 角色权限</div>
              </div>
            </div>
          </div>

          <div class="knowledge-modal-footer dir-config-footer">
            <Button @click="handleDirModalCancel">{{ dirModalReadOnly ? '关闭' : '取消' }}</Button>
            <Button v-if="!dirModalReadOnly" type="primary" @click="handlePermissionSubmit" style="margin-left:10px;">保存</Button>
          </div>
        </Modal>

        <!-- 内容编辑抽屉 -->
        <Drawer
          v-model="showItemEditor"
          :width="1120"
          :mask-closable="false"
          class-name="knowledge-item-editor-drawer"
          :styles="{ padding: 0 }"
        >
          <div class="item-editor-shell">
            <div class="item-editor-header">
              <div class="item-editor-header-left">
                <span class="item-editor-mode">{{ itemForm.id ? '编辑内容' : '新建内容' }}</span>
                <span class="item-editor-subtitle">{{ currentTypeLabel }}</span>
              </div>
              <div class="item-editor-nav">
                <button
                  type="button"
                  class="item-editor-nav-btn"
                  :class="{ active: editorTab === 'basic' }"
                  @click="editorTab = 'basic'"
                >基本信息</button>
                <button
                  type="button"
                  class="item-editor-nav-btn"
                  :class="{ active: editorTab === 'markdown' }"
                  @click="editorTab = 'markdown'"
                >Markdown 解析</button>
              </div>
            </div>

            <div v-show="editorTab === 'basic'" class="item-editor-body item-editor-body--basic">
              <div class="item-editor-layout">
                <aside class="item-editor-sidebar">
                  <div class="sidebar-section">
                    <div class="sidebar-label">内容类型</div>
                    <div class="type-selector type-selector-vertical">
                      <div
                        v-for="typeOption in typeOptions"
                        :key="typeOption.value"
                        class="type-option"
                        :class="{ active: itemForm.type === typeOption.value }"
                        @click="itemForm.type = typeOption.value; handleItemTypeChange()"
                      >
                        <BaseIcon :icon="typeOption.icon" :size="22" />
                        <span>{{ typeOption.label }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="sidebar-section">
                    <div class="sidebar-label">所属目录</div>
                    <Select v-model="itemForm.dir_id" clearable size="large" transfer>
                      <Option value="">无</Option>
                      <Option v-for="dir in allDirectories" :key="dir.id" :value="dir.id">{{ dir.name }}</Option>
                    </Select>
                  </div>
                </aside>

                <main class="item-editor-main">
                  <div class="editor-field editor-field--static">
                    <label class="editor-field-label">标题</label>
                    <Input
                      v-model="itemForm.name"
                      placeholder="请输入标题"
                      size="large"
                      :maxlength="100"
                      class="editor-title-input"
                    />
                  </div>

                  <div class="editor-field editor-field--static" v-if="itemForm.type === 'file'">
                    <label class="editor-field-label">文件上传</label>
                    <div class="editor-upload-card">
                      <Upload :before-upload="handleFileUpload" action="">
                        <Button icon="ios-cloud-upload-outline" type="primary" ghost size="large">选择文件</Button>
                      </Upload>
                      <div v-if="itemForm.content" class="editor-file-preview">
                        <BaseIcon icon="wenjian" :size="18" />
                        <a :href="itemForm.content" target="_blank">{{ itemForm.content }}</a>
                      </div>
                      <div v-else class="editor-file-empty">尚未上传文件</div>
                    </div>
                  </div>

                  <div class="editor-field editor-field--scroll" v-if="itemForm.type === 'text'">
                    <label class="editor-field-label">文本内容</label>
                    <div class="editor-scroll-panel">
                      <Input
                        v-model="itemForm.content"
                        type="textarea"
                        placeholder="请输入文本内容"
                        class="editor-textarea editor-textarea--fill"
                      />
                    </div>
                  </div>

                  <div class="editor-field editor-field--fill" v-if="itemForm.type === 'md'">
                    <label class="editor-field-label">Markdown 内容</label>
                    <div class="markdown-editor-wrapper editor-content-panel editor-content-panel--fill">
                      <MarkdownEditor v-model="itemForm.content" height="100%" />
                    </div>
                  </div>

                  <div class="editor-field editor-field--fill" v-if="itemForm.type === 'html'">
                    <label class="editor-field-label">HTML 内容</label>
                    <div class="html-editor-wrapper editor-content-panel editor-content-panel--fill">
                      <TextEditor v-model="itemForm.content" />
                    </div>
                  </div>
                </main>
              </div>
            </div>

            <div v-show="editorTab === 'markdown'" class="item-editor-body item-editor-body--markdown">
              <div class="item-editor-markdown-toolbar">
                <Alert show-icon type="info" class="markdown-parse-tip">
                  支持 PDF、DOCX 及图片文件手动解析为 Markdown，用于摘要检索；解析结果末尾将自动附上原文链接。
                </Alert>
                <div class="markdown-parse-meta">
                  <span class="markdown-parse-label">解析状态</span>
                  <Tag :color="itemForm.has_markdown ? 'success' : 'default'">
                    {{ itemForm.has_markdown ? '已生成 Markdown' : '未解析' }}
                  </Tag>
                  <Button
                    v-if="showMarkdownParseBtn"
                    type="primary"
                    ghost
                    size="small"
                    :loading="markdownParsing"
                    @click="handleParseMarkdown"
                  >手动解析</Button>
                </div>
                <div v-if="itemForm.content && itemForm.type === 'file'" class="editor-source-link">
                  <span class="markdown-parse-label">原文链接</span>
                  <a :href="itemForm.content" target="_blank">{{ itemForm.content }}</a>
                </div>
              </div>
              <div class="editor-field editor-field--fill">
                <label class="editor-field-label">摘要内容</label>
                <div class="markdown-editor-wrapper editor-content-panel editor-content-panel--fill">
                  <MarkdownEditor v-model="itemForm.markdown_content" height="100%" />
                </div>
              </div>
            </div>

            <div class="knowledge-modal-footer item-editor-footer">
              <Button @click="handleItemCancel" size="large">取消</Button>
              <Button type="primary" @click="handleItemSubmit" size="large" style="margin-left:10px;">保存</Button>
            </div>
          </div>
        </Drawer>

        <Modal
          v-model="decomposeModalVisible"
          title="知识拆解"
          width="880"
          :mask-closable="false"
          class-name="knowledge-decompose-modal"
          @on-cancel="closeDecomposeModal"
        >
          <div v-if="decomposeStep === 'select'" class="decompose-step decompose-step--select">
            <Alert show-icon type="info" class="decompose-tip">
              选择要拆解的内容，AI 将拆分为独立知识点；确认后每个知识点保存为单独的 Markdown 文件，并关联原文。
            </Alert>
            <div v-if="!selectedDir" class="decompose-empty">请先选择目录</div>
            <div v-else-if="decomposableItemsInDir.length === 0" class="decompose-empty">
              当前目录没有可拆解的内容（需 text / md / html，或已解析的 file）
            </div>
            <div v-else class="decompose-select-list">
              <Checkbox
                :indeterminate="decomposeSelectIndeterminate"
                :value="decomposeSelectAll"
                @click.prevent.native="toggleDecomposeSelectAll"
                class="decompose-select-all"
              >全选</Checkbox>
              <CheckboxGroup v-model="decomposeSelectedIds" class="decompose-checkbox-group">
                <div
                  v-for="item in decomposableItemsInDir"
                  :key="item.id"
                  class="decompose-select-item"
                >
                  <Checkbox :label="String(item.id)">
                    <span class="decompose-item-title">{{ getDecomposeItemTitle(item) }}</span>
                    <Tag size="small" class="decompose-item-type">{{ getDecomposeItemTypeLabel(item) }}</Tag>
                  </Checkbox>
                </div>
              </CheckboxGroup>
            </div>
          </div>

          <div v-else-if="decomposeStep === 'analyzing'" class="decompose-step decompose-step--analyzing">
            <Spin size="large" fix />
            <div class="decompose-analyzing-text">
              <BaseIcon icon="md-color-wand" :size="28" color="var(--primary)" />
              <p>AI 正在拆解知识，请稍候…</p>
              <p v-if="decomposeProgress" class="decompose-progress">{{ decomposeProgress }}</p>
            </div>
          </div>

          <div v-else-if="decomposeStep === 'preview'" class="decompose-step decompose-step--preview">
            <Alert show-icon type="success" class="decompose-tip">
              共拆解出 {{ decomposePreviewPointCount }} 个知识点，请确认后保存。可取消勾选不需要的条目，或修改标题。
            </Alert>
            <div class="decompose-preview-groups">
              <div
                v-for="group in decomposePreviewGroups"
                :key="group.sourceId"
                class="decompose-preview-group"
              >
                <div class="decompose-group-header">
                  <span class="decompose-group-title">{{ group.sourceName }}</span>
                  <Tag>{{ group.points.length }} 个知识点</Tag>
                </div>
                <div
                  v-for="(point, idx) in group.points"
                  :key="group.sourceId + '-' + idx"
                  class="decompose-preview-point"
                >
                  <Checkbox v-model="point.selected" class="decompose-point-check" />
                  <div class="decompose-point-body">
                    <Input v-model="point.title" size="small" class="decompose-point-title-input" />
                    <p v-if="point.summary" class="decompose-point-summary">{{ point.summary }}</p>
                    <pre class="decompose-point-content">{{ point.content }}</pre>
                    <p v-if="point.quote" class="decompose-point-quote">摘录：{{ point.quote }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div slot="footer" class="decompose-modal-footer">
            <Button @click="closeDecomposeModal">取消</Button>
            <Button
              v-if="decomposeStep === 'select'"
              type="primary"
              :disabled="!decomposeSelectedIds.length"
              @click="startDecompose"
            >开始拆解</Button>
            <Button
              v-if="decomposeStep === 'preview'"
              type="primary"
              :loading="decomposeSaving"
              :disabled="decomposePreviewSelectedCount === 0"
              @click="confirmDecomposeSave"
            >确认保存（{{ decomposePreviewSelectedCount }}）</Button>
          </div>
        </Modal>

        <Modal
          v-model="mdConflictVisible"
          title="发现同名文件"
          :mask-closable="false"
          width="520"
          class-name="knowledge-md-conflict-modal"
        >
          <Alert show-icon type="warning">
            目录中已存在同名 Markdown「{{ mdConflict && mdConflict.targetName }}」。
          </Alert>
          <p class="md-conflict-desc">
            源文件：{{ mdConflict && mdConflict.sourceName }}
          </p>
          <p class="md-conflict-desc">
            是否继续生成？若继续，可选择覆盖已有 Markdown，或另存为新文件。
          </p>
          <div slot="footer">
            <Button @click="cancelMdConflict">取消</Button>
            <Button @click="confirmMdConflict('saveas')">继续（另存）</Button>
            <Button type="primary" @click="confirmMdConflict('overwrite')">继续并覆盖</Button>
          </div>
        </Modal>

        <MineruParseTaskPanel
          v-if="mineruTasks.length"
          :tasks="mineruTasks"
          @cancel="cancelMineruTask"
          @retry="retryMineruTask"
          @dismiss="dismissMineruTask"
          @clear-finished="clearFinishedMineruTasks"
        />
  </div>
</template>

<script>
import KnowledgeDirectory from '@/components/knowledge/directory'
import KnowledgeList from '@/components/knowledge/list'
import KnowledgeDetail from '@/components/knowledge/detail'
import MineruParseTaskPanel from '@/components/knowledge/MineruParseTaskPanel'
import Toolbar from '@/components/app/toolbar'
import MarkdownEditor from '@/components/base/MarkdownEditor'
import TextEditor from '@/components/base/TextEditor'
import BaseIcon from '@/components/base/Icon'
import UTIL from '@/utils'
import { mapGetters } from 'vuex'
import {
  estimateMineruTaskProgress,
  getFileBaseName,
  getFileExtFromName,
  isMdGenerateFileName,
  isParseableFileName,
  parseRemoteFileToMarkdown,
  parseRemoteFileToMarkdownViaTask,
  pollMineruTask,
  resolveRemoteFileUrl,
} from '@/utils/mineru-parse'
import {
  isMineruTaskActive,
  loadMineruTasksFromStorage,
  needsMineruTaskResume,
  saveMineruTasksToStorage,
} from '@/utils/mineru-task-store'
import {
  DIR_DATA_TYPES,
  DIR_TYPES,
  DIR_VIEW_FILTERS,
  buildAclPayload,
  canEditDirectory,
  canManageDirectory,
  canViewDirectory,
  dedupeDirectoryFlat,
  extractDirectorySubtree,
  filterDirectoryTree,
  filterViewableDirectoryTree,
  filterEditableDirectoryTree,
  canUploadToDirectory,
  getAllowedContentTypes,
  getAllowedUploadAccept,
  getCreatableDirDataTypes,
  getEmptyUploadLabel,
  isDirectoryUploadEnabled,
  isDocumentDirectory,
  resolveUploadItemType,
  getDirDescription,
  getDirectoryVueKey,
  getEffectiveOwnerId,
  getEffectivePermissions,
  getKnowledgeRoleDisplay,
  getRefDirectoryTargetId,
  isRefDirectory,
  markRefDisplayTree,
  resolveDirectoryContentRoot,
  sortDirListByName,
  isRemoteDirectory,
  isSystemDirectory,
  normalizeAclRow,
  normalizeDirDataType,
  normalizeDirType,
  normalizeKnowledgeAuth,
  PLATFORM_ADMIN_ROLE,
} from './knowledge-permissions'
import {
  buildDecomposePrompt,
  buildKnowledgePointMd,
  extractAiCompletionText,
  getItemDisplayTitle,
  isDecomposableItem,
  newSplitGroupId,
  parseDecomposeResult,
  resolveItemTextForDecompose,
} from './knowledge-decompose'

const EMPTY_PERMISSION_FORM = () => ({
  id: null,
  name: '',
  parent_id: null,
  type: 'dir',
  data_type: 'raw',
  is_shared: false,
  is_private: true,
  editable: true,
  enable_approval: false,
  enable_create_sub: true,
  enable_upload: true,
  description: '',
  owner_id: '',
  remote_api: '',
  permissions: [],
})

const EMPTY_PERM_ADD_FORM = () => ({
  client_type: 'user',
  client_id: '',
  mod: 'view',
  effect: 'allow',
})

export default {
    routerOption: {},
    props: {
      hideViewModeBar: {
        type: Boolean,
        default: false,
      },
      libraryViewMode: {
        type: String,
        default: null,
      },
    },
    data(){
      return {
        directories:[],
        items:[],
        allItems:[],
        loading:false,
        showDetail:false,
        current:null,
        selectedDir:null,
        selectedItems:[],
        searchText:'',
        dirSearchText:'',
        dirViewFilter:'all',
        toolBarValue:{
          view_mode:'icon'
        },
        editorTab: 'basic',
        markdownParsing: false,
        aclRoles: [],
        aclGroups: [],
        aclSaving: false,
        knowledgeAuth: {
          roles: [],
          groups: [],
        },
        knowledgeAuthLoaded: false,
        dirTreeExpandToken: { version: 0, expanded: true },
        showItemEditor:false,
        itemForm:{
          type:'text',
          content:'',
          dir_id:'',
          markdown_content:'',
          has_markdown: false,
        },
        showDirPermission:false,
        permissionDir:null,
        permissionForm: EMPTY_PERMISSION_FORM(),
        showPermAddForm: false,
        permAddForm: EMPTY_PERM_ADD_FORM(),
        dirModalReadOnly: false,
        permissionViewRefSource: false,
        permissionRefDir: null,
        decomposeModalVisible: false,
        decomposeStep: 'select',
        decomposeSelectedIds: [],
        decomposePreviewGroups: [],
        decomposeProgress: '',
        decomposeSaving: false,
        mineruTasks: [],
        mdConflictVisible: false,
        mdConflict: null,
        mineruTaskSeq: 0,
        mineruAbortMap: {},
        localLibraryViewMode: 'all',
      }
    },
    components:{KnowledgeDirectory,KnowledgeList,Toolbar,KnowledgeDetail,MarkdownEditor,TextEditor,BaseIcon,MineruParseTaskPanel},
    computed:{
      resolvedLibraryViewMode() {
        if (this.hideViewModeBar) {
          return this.libraryViewMode === 'edit' ? 'edit' : 'all'
        }
        return this.localLibraryViewMode === 'edit' ? 'edit' : 'all'
      },
      ...mapGetters('session', ['deps', 'projects', 'users', 'session']),
      dirTypeOptions() {
        return DIR_TYPES
      },
      dirTypeButtonOptions() {
        return DIR_TYPES
      },
      refDirectoryOptions() {
        return (this.allDirectories || []).filter((dir) => {
          if (isSystemDirectory(dir)) return false
          if (this.permissionForm.id && this.sameId(dir.id, this.permissionForm.id)) return false
          return true
        })
      },
      dirDataTypeOptions() {
        return DIR_DATA_TYPES
      },
      creatableDirDataTypeOptions() {
        return getCreatableDirDataTypes()
      },
      permissionParentDir() {
        const parentId = this.permissionForm && this.permissionForm.parent_id
        if (parentId == null || parentId === '') return null
        return this.findDirectoryById(parentId)
      },
      isPermissionUnderDocumentDir() {
        return isDocumentDirectory(this.permissionParentDir, this.allDirectories)
      },
      isPermissionDocumentDir() {
        if (normalizeDirDataType(this.permissionForm.data_type) === 'parsed') return true
        return this.isPermissionUnderDocumentDir
      },
      dirDataTypeLocked() {
        // 文档目录上下文：新建/编辑时数据类型锁定为文档目录
        if (this.isPermissionUnderDocumentDir) return true
        // 已有文档目录不可改为其他类型
        if (this.permissionForm.id && normalizeDirDataType(this.permissionForm.data_type) === 'parsed') {
          return true
        }
        return false
      },
      allowedDirDataTypes() {
        if (!this.isConfigLocalDir) return []
        if (this.isPermissionUnderDocumentDir) {
          return DIR_DATA_TYPES.filter((item) => item.value === 'parsed')
        }
        return getCreatableDirDataTypes(this.permissionParentDir, this.allDirectories)
      },
      dirViewFilterOptions() {
        return DIR_VIEW_FILTERS
      },
      displayDirectories() {
        let tree = filterDirectoryTree(this.directories, {
          keyword: this.dirSearchText,
          viewFilter: this.dirViewFilter,
        })
        tree = filterViewableDirectoryTree(
          tree,
          this.session,
          this.allDirectories,
          this.knowledgeAuth,
        )
        if (this.resolvedLibraryViewMode === 'edit') {
          tree = filterEditableDirectoryTree(
            tree,
            this.session,
            this.allDirectories,
            this.knowledgeAuth,
          )
        }
        return tree
      },
      dirModalTitle() {
        if (this.dirModalReadOnly && this.permissionViewRefSource) return '引用目录配置（只读）'
        if (this.dirModalReadOnly) return '目录配置（只读）'
        return this.permissionForm.id ? '目录配置' : '新建目录'
      },
      configDirTypeLabel() {
        const type = normalizeDirType(this.permissionForm.type)
        const opt = DIR_TYPES.find(item => item.value === type)
        return opt ? opt.label : type
      },
      configDirDataTypeLabel() {
        const dataType = normalizeDirDataType(this.permissionForm.data_type)
        const opt = DIR_DATA_TYPES.find(item => item.value === dataType)
        return opt ? opt.label : dataType
      },
      configDirDataTypeIcon() {
        const dataType = normalizeDirDataType(this.permissionForm.data_type)
        const opt = DIR_DATA_TYPES.find(item => item.value === dataType)
        return opt ? opt.icon : ''
      },
      permissionInternalPublic: {
        get() {
          return !this.permissionForm.is_private
        },
        set(val) {
          this.permissionForm.is_private = !val
        },
      },
      sessionDeps() {
        return this.deps || []
      },
      sessionProjects() {
        return this.projects || []
      },
      aclGroupOptions() {
        if (this.aclGroups.length) return this.aclGroups
        return this.sessionDeps || []
      },
      viewMode(){
        if(this.toolBarValue){
          return this.toolBarValue.view_mode
        }
        return 'icon'
      },
      filteredItems(){
        if (!this.selectedDir) return []
        const contentRoot = this.resolveContentDirectory(this.selectedDir)
        const dirIds = this.getDirIdWithDescendants(contentRoot.id)
        let items = this.allItems.filter(item => item.dir_id && dirIds.some(id => this.sameId(id, item.dir_id)))
        if(this.searchText){
          const search = this.searchText.toLowerCase()
          items = items.filter(item => {
            const name = (item.name || '').toLowerCase()
            const content = (item.content || '').toLowerCase()
            return name.includes(search) || content.includes(search)
          })
        }
        return items
      },
      selectedDirPath(){
        if(!this.selectedDir) return ''
        return this.selectedDirPathArray.map(d => d.name).join(' / ')
      },
      selectedDirPathArray(){
        if(!this.selectedDir) return []
        const path = []
        let cur = this.selectedDir
        while(cur){
          path.unshift(cur)
          if(!cur.parent_id) break
          cur = this.allDirectories.find(d => d.id === cur.parent_id) || null
        }
        return path
      },
      selectedSubdirs(){
        if(!this.selectedDir) return []
        const contentRoot = this.resolveContentDirectory(this.selectedDir)
        if (!contentRoot) return []
        const seen = new Set()
        const children = dedupeDirectoryFlat(
          (this.allDirectories || []).filter(dir => this.sameId(dir.parent_id, contentRoot.id)),
        )
        return sortDirListByName(children.filter((dir) => {
          const id = String(dir.id)
          if (seen.has(id)) return false
          seen.add(id)
          return canViewDirectory(
            this.session,
            this.resolveContentDirectory(dir) || dir,
            this.allDirectories,
            this.knowledgeAuth,
          )
        }))
      },
      selectedDirEditable(){
        if(!this.selectedDir) return true
        const contentRoot = this.resolveContentDirectory(this.selectedDir)
        return canEditDirectory(
          this.session,
          contentRoot,
          this.allDirectories,
          this.knowledgeAuth,
        )
      },
      canManageSelectedDir() {
        if (!this.selectedDir) return false
        return canManageDirectory(
          this.session,
          this.findDirectoryById(this.selectedDir.id) || this.selectedDir,
          this.allDirectories,
          this.knowledgeAuth,
        )
      },
      canConfigSelectedDir() {
        if (!this.selectedDir) return false
        if (isSystemDirectory(this.selectedDir)) return false
        if (isRefDirectory(this.selectedDir) || this.selectedDir._refDisplay) {
          const opDir = this.resolveOperationDirectory(this.selectedDir)
          return opDir && canViewDirectory(
            this.session,
            opDir,
            this.allDirectories,
            this.knowledgeAuth,
          )
        }
        return this.canManageSelectedDir
      },
      canDeleteSelectedDir() {
        if (!this.selectedDir) return false
        if (isRefDirectory(this.selectedDir)) {
          return canManageDirectory(
            this.session,
            this.selectedDir,
            this.allDirectories,
            this.knowledgeAuth,
          )
        }
        const opDir = this.resolveOperationDirectory(this.selectedDir)
        return opDir && canManageDirectory(
          this.session,
          opDir,
          this.allDirectories,
          this.knowledgeAuth,
        )
      },
      canViewSelectedDir() {
        if (!this.selectedDir) return false
        return canViewDirectory(
          this.session,
          this.findDirectoryById(this.selectedDir.id) || this.selectedDir,
          this.allDirectories,
          this.knowledgeAuth,
        )
      },
      selectedDirStatusDir() {
        if (!this.selectedDir) return null
        return this.resolveOperationDirectory(this.selectedDir)
      },
      selectedDirOwnerId() {
        const dir = this.selectedDirStatusDir
        if (!dir) return null
        return getEffectiveOwnerId(dir, this.allDirectories)
      },
      selectedDirTypeLabel() {
        if (!this.selectedDir) return ''
        if (isRefDirectory(this.selectedDir)) {
          const opt = DIR_TYPES.find(item => item.value === 'ref')
          return opt ? opt.label : '引用目录'
        }
        const dir = this.selectedDirStatusDir
        if (!dir) return ''
        const type = normalizeDirType(dir.type)
        const opt = DIR_TYPES.find(item => item.value === type)
        return opt ? opt.label : type
      },
      selectedDirDataTypeLabel() {
        const dir = this.selectedDirStatusDir
        if (!dir) return ''
        if (normalizeDirType(dir.type) !== 'dir') return ''
        const dataType = normalizeDirDataType(dir.data_type)
        const opt = DIR_DATA_TYPES.find(item => item.value === dataType)
        return opt ? opt.label : dataType
      },
      selectedContentDirId() {
        if (!this.selectedDir) return null
        const contentRoot = this.resolveContentDirectory(this.selectedDir)
        return contentRoot ? contentRoot.id : null
      },
      isConfigRemoteDir() {
        return normalizeDirType(this.permissionForm.type) === 'remote'
      },
      isSelectedRefContext() {
        if (!this.selectedDir) return false
        return isRefDirectory(this.selectedDir) || !!this.selectedDir._refDisplay
      },
      isConfigRefDir() {
        return normalizeDirType(this.permissionForm.type) === 'ref'
      },
      isConfigLocalDir() {
        return normalizeDirType(this.permissionForm.type) === 'dir'
      },
      focusDirId() {
        const dir = this.$route && this.$route.query && this.$route.query.dir
        return dir != null && String(dir).trim() !== '' ? String(dir).trim() : ''
      },
      isSelectedDirRoot(){
        if(!this.selectedDir) return false
        return this.selectedDir.parent_id === null || this.selectedDir.parent_id === undefined || this.selectedDir._focusRoot
      },
      allDirectories(){
        return dedupeDirectoryFlat(UTIL.plat(this.directories, {LIST_KEY: 'children'}) || [])
      },
      availableDirectories(){
        if (!this.permissionForm.id) return this.allDirectories
        return this.allDirectories.filter(dir => !this.sameId(dir.id, this.permissionForm.id))
      },
      typeOptions(){
        const all = [
          { value: 'file', label: '文件', icon: 'wenjian' },
          { value: 'text', label: '文本', icon: 'md-document' },
          { value: 'md', label: 'Markdown', icon: 'logo-markdown' },
          { value: 'html', label: 'HTML', icon: 'css' },
        ]
        const dir = this.selectedDir ? (this.findDirectoryById(this.selectedDir.id) || this.selectedDir) : null
        if (!dir) return all
        const allowed = getAllowedContentTypes(dir, this.allDirectories)
        return all.filter(item => allowed.includes(item.value))
      },
      allowedContentTypes() {
        const dir = this.selectedDir ? this.resolveOperationDirectory(this.selectedDir) : null
        if (!dir) return []
        return getAllowedContentTypes(dir, this.allDirectories)
      },
      uploadAccept() {
        return getAllowedUploadAccept(this.allowedContentTypes)
      },
      canUploadFiles() {
        if (!this.selectedDirUploadEnabled) return false
        return canUploadToDirectory(this.allowedContentTypes)
      },
      selectedDirUploadEnabled() {
        if (!this.selectedDir) return false
        const contentRoot = this.resolveContentDirectory(this.selectedDir)
        return isDirectoryUploadEnabled(contentRoot, this.allDirectories)
      },
      canCreateFiles() {
        return !!(this.selectedDir && this.selectedDirEditable && this.selectedDirUploadEnabled)
      },
      emptyUploadLabel() {
        return getEmptyUploadLabel(this.allowedContentTypes)
      },
      decomposableItemsInDir() {
        if (!this.selectedDir) return []
        const contentRoot = this.resolveContentDirectory(this.selectedDir)
        if (!contentRoot) return []
        const dirIds = this.getDirIdWithDescendants(contentRoot.id)
        return (this.allItems || []).filter((item) => {
          if (!item.dir_id || !dirIds.some((id) => this.sameId(id, item.dir_id))) return false
          return isDecomposableItem(item, this.allItems)
        })
      },
      decomposeSelectAll() {
        const all = this.decomposableItemsInDir.map((item) => String(item.id))
        return all.length > 0 && all.every((id) => this.decomposeSelectedIds.includes(id))
      },
      decomposeSelectIndeterminate() {
        const all = this.decomposableItemsInDir.map((item) => String(item.id))
        const selected = this.decomposeSelectedIds.filter((id) => all.includes(id))
        return selected.length > 0 && selected.length < all.length
      },
      decomposePreviewPointCount() {
        return (this.decomposePreviewGroups || []).reduce((sum, g) => sum + (g.points || []).length, 0)
      },
      decomposePreviewSelectedCount() {
        return (this.decomposePreviewGroups || []).reduce((sum, g) => {
          return sum + (g.points || []).filter((p) => p.selected).length
        }, 0)
      },
      directoryTools(){
        const hasSelected = !!this.selectedDir
        const isRoot = hasSelected && (this.selectedDir.parent_id === null || this.selectedDir.parent_id === undefined)
        const isSystem = hasSelected && isSystemDirectory(this.selectedDir)
        const opDir = hasSelected ? this.resolveOperationDirectory(this.selectedDir) : null
        const notEditable = hasSelected && !this.selectedDirEditable
        const notCreateSub = hasSelected && opDir && opDir.enable_create_sub === false
        const canConfig = this.canConfigSelectedDir
        const canDelete = this.canDeleteSelectedDir
        const editBtns = (!hasSelected || isRoot || isSystem || !canConfig) ? [] : [{
          type:"icon-button",
          icon:'md-create',
          name: isRefDirectory(this.selectedDir) || this.selectedDir._refDisplay ? '配置' : '编辑',
          key:'edit',
          disabled:false,
        },{
          type:"icon-button",
          icon:'md-trash',
          name:'删除',
          key:'remove',
          disabled: !canDelete,
        }]

        const canShowAdd = hasSelected && this.selectedDirEditable && !notCreateSub
        const tools = []
        if (canShowAdd) {
          tools.push({
            type:"icon-button",
            icon:'md-add',
            name:'新增',
            key:'add',
            disabled: false,
          })
        }
        return [...tools, ...editBtns]
      },
      dataTools(){
        const hasSelected = this.selectedItems.length > 0
        const canEdit = this.selectedItems.length === 1
        const canMirror = this.selectedItems.length > 0 && this.selectedItems.every(item => item.type !== 'ref')
        const dirEditable = this.selectedDir && this.selectedDirEditable
        const canUpload = this.canCreateFiles && this.canUploadFiles

        const editBtn = canEdit ? [{
          type: 'icon-button',
          icon: 'md-create',
          name: '编辑',
          key: 'edit',
          disabled: false,
        }] : []

        const actionBtns = hasSelected ? [{
          type: 'icon-button',
          icon: 'md-copy',
          name: '镜像',
          key: 'mirror',
          disabled: !canMirror,
        }, {
          type: 'icon-button',
          icon: 'md-trash',
          name: '删除',
          key: 'remove',
          disabled: false,
        }] : []

        return [{
          type: 'icon-button',
          icon: 'md-add',
          name: '上传',
          key: 'upload',
          disabled: !canUpload,
        }, {
          type: 'icon-button',
          icon: 'ios-create-outline',
          name: '新建',
          key: 'add',
          disabled: !this.canCreateFiles,
        }, {
          type: 'icon-button',
          icon: 'md-color-wand',
          name: '拆解',
          key: 'decompose',
          disabled: !this.canCreateFiles,
        },
        ...editBtn,
        ...actionBtns,
        {
          type: 'divider',
        },
        {
          type:'tabs',
          key:'view_mode',
          subs:[{
          type:"icon-button",
          icon:'md-speedometer',
          name:'图标',
          togglable:true,
          key:'icon',
        },{
          type:"icon-button",
          icon:'pm2',
          name:'列表',
          togglable:true,
          key:'list',
        },{
          type:"icon-button",
          icon:'pm2',
          name:'大纲',
          togglable:true,
          key:'brief',
        }]
        }]
      },
      itemEditorTitle(){
        return this.itemForm.id ? '编辑内容' : '新建内容'
      },
      showMarkdownParseBtn() {
        return this.itemForm.type === 'file' && isParseableFileName(this.itemForm.content);
      },
      currentTypeLabel() {
        const found = this.typeOptions.find(item => item.value === this.itemForm.type);
        return found ? found.label : '内容';
      },
      knowledgeRoleText() {
        return getKnowledgeRoleDisplay(this.session, this.knowledgeAuth);
      },
    },
    watch: {
      focusDirId(newId, oldId) {
        if (String(newId || '') === String(oldId || '')) return
        if (!this.knowledgeAuthLoaded) return
        this.fetchDirectories()
      },
      resolvedLibraryViewMode(mode) {
        if (mode !== 'edit') return
        if (!this.selectedDir) return
        if (this.selectedDirEditable) return
        // 切到编辑视图时，若当前选中目录不可编辑则清空选中
        this.selectedDir = null
      },
    },
    mounted(){
      this.loading = true
      this.restoreMineruTasksFromStorage()
      this.$api.afterLogin(()=>{
        this.fetchKnowledgeAuth().then(() => {
          this.fetchDirectories()
          this.fetchItems()
          this.resumeMineruTasksAfterLogin()
        })
      })
    },
    beforeDestroy() {
      // 只停止本地轮询，不标记取消，便于刷新后续传
      Object.keys(this.mineruAbortMap || {}).forEach((key) => {
        const controller = this.mineruAbortMap[key]
        if (controller && controller.abort) controller.abort()
      })
      this.mineruAbortMap = {}
      this.persistMineruTasks()
    },
    methods:{
      getDirectoryVueKey,
      setLibraryViewMode(mode) {
        const next = mode === 'edit' ? 'edit' : 'all'
        if (this.hideViewModeBar) {
          this.$emit('update:libraryViewMode', next)
          return
        }
        this.localLibraryViewMode = next
      },
      sameId(a, b) {
        if (a == null || b == null || a === '' || b === '') return false;
        return String(a) === String(b);
      },
      findDirectoryInTree(nodes, id) {
        if (id == null || id === '') return null
        let found = null
        const walk = (items) => {
          (items || []).some((node) => {
            if (this.sameId(node.id, id)) {
              found = node
              return true
            }
            return walk(node.children || node.subs)
          })
        }
        walk(nodes)
        return found
      },
      setDirectoryChildren(dirId, children) {
        const walk = (nodes) => {
          (nodes || []).some((node) => {
            if (this.sameId(node.id, dirId)) {
              this.$set(node, 'children', children)
              return true
            }
            return walk(node.children || node.subs)
          })
        }
        walk(this.directories)
      },
      cloneDirectoryTreeNodes(nodes) {
        return markRefDisplayTree(nodes || [], true)
      },
      loadRefDirectoryChildren(refDir) {
        const targetId = getRefDirectoryTargetId(refDir)
        if (!targetId || !refDir || refDir.id == null) return Promise.resolve()
        const targetInTree = this.findDirectoryInTree(this.directories, targetId)
        if (targetInTree && Array.isArray(targetInTree.children) && targetInTree.children.length) {
          this.setDirectoryChildren(refDir.id, this.cloneDirectoryTreeNodes(targetInTree.children))
          return Promise.resolve()
        }
        return this.$api.get(`/knowledge/directories/${targetId}`).then((res) => {
          const data = (res.data && res.data.data) != null ? res.data.data : (res.data || {})
          const children = this.cloneDirectoryTreeNodes(data.children || data.subs || [])
          this.setDirectoryChildren(refDir.id, children)
        }).catch((err) => {
          this.$Message.error('加载引用目录失败: ' + err)
        })
      },
      findDirectoryById(id) {
        const flat = this.allDirectories.find(dir => this.sameId(dir.id, id))
        if (flat) return flat
        return this.findDirectoryInTree(this.directories, id)
      },
      resolveOperationDirectory(dir) {
        if (!dir) return null
        if (isRefDirectory(dir)) {
          return this.resolveContentDirectory(dir) || dir
        }
        return this.findDirectoryById(dir.id) || dir
      },
      resolveContentDirectory(dir) {
        const current = dir ? (this.findDirectoryById(dir.id) || dir) : null
        return resolveDirectoryContentRoot(current, this.allDirectories) || current
      },
      buildDirModalForm(dir, overrides = {}) {
        const permissions = (() => {
          if (!dir) return []
          if (Array.isArray(dir.permissions) && dir.permissions.length) {
            return dir.permissions.map(normalizeAclRow).filter(item => !!item.client_id)
          }
          return getEffectivePermissions(dir, this.allDirectories)
            .map(normalizeAclRow)
            .filter(item => !!item.client_id)
        })()
        const type = normalizeDirType(dir && dir.type)
        const dataType = normalizeDirDataType(dir && dir.data_type)
        return {
          id: dir && dir.id != null ? dir.id : null,
          name: (dir && dir.name) || '',
          parent_id: dir && dir.parent_id != null ? dir.parent_id : null,
          type,
          data_type: dataType,
          is_shared: !!(dir && dir.is_shared),
          is_private: dir ? dir.is_private !== false : true,
          editable: type === 'remote' ? false : (dir ? dir.editable !== false : true),
          enable_approval: !!(dir && dir.enable_approval),
          enable_create_sub: dir ? dir.enable_create_sub !== false : true,
          enable_upload: dir ? dir.enable_upload !== false : true,
          description: getDirDescription(dir),
          owner_id: dir
            ? ((dir.owner_id != null && dir.owner_id !== '')
              ? dir.owner_id
              : (dir.created_by || dir.charger_id || ''))
            : '',
          remote_api: type === 'ref'
            ? (getRefDirectoryTargetId(dir) || '')
            : (type === 'remote' ? ((dir && dir.remote_api) || '') : ''),
          permissions,
          ...overrides,
        }
      },
      openDirModal(dir, overrides = {}) {
        const sourceDir = dir ? (this.findDirectoryById(dir.id) || dir) : null
        if (sourceDir && isSystemDirectory(sourceDir)) {
          this.$Message.warning('系统目录不可编辑属性')
          return
        }
        let currentDir = sourceDir
        let readOnly = false
        let viewRefSource = false
        let refDir = null

        if (sourceDir && isRefDirectory(sourceDir)) {
          refDir = sourceDir
          const target = this.resolveContentDirectory(sourceDir)
          if (!target) {
            this.$Message.warning('未找到引用目标目录')
            return
          }
          currentDir = this.findDirectoryById(target.id) || target
          readOnly = true
          viewRefSource = true
        } else if (sourceDir && sourceDir._refDisplay && sourceDir.id) {
          currentDir = this.findDirectoryById(sourceDir.id) || sourceDir
          readOnly = true
        }

        if (currentDir && readOnly) {
          if (!canViewDirectory(this.session, currentDir, this.allDirectories, this.knowledgeAuth)) {
            this.$Message.warning('无权查看该目录配置')
            return
          }
        } else if (currentDir && !canManageDirectory(this.session, currentDir, this.allDirectories, this.knowledgeAuth)) {
          this.$Message.warning('无权配置该目录')
          return
        }

        this.dirModalReadOnly = readOnly
        this.permissionViewRefSource = viewRefSource
        this.permissionRefDir = refDir
        this.permissionDir = currentDir
        this.permissionForm = this.buildDirModalForm(currentDir, overrides)
        // 文档目录下新建子目录：强制文档目录类型
        if (!this.permissionForm.id) {
          const parent = this.permissionForm.parent_id != null
            ? this.findDirectoryById(this.permissionForm.parent_id)
            : null
          if (isDocumentDirectory(parent, this.allDirectories)) {
            this.permissionForm.data_type = 'parsed'
            this.permissionForm.type = 'dir'
          }
        }
        this.resetPermAddForm()
        if (currentDir && currentDir.id) {
          this.fetchAclMeta()
        }
        this.showDirPermission = true
      },
      isDirWritable(dir) {
        const current = dir ? (this.findDirectoryById(dir.id) || dir) : null
        if (!current) return false
        const contentRoot = this.resolveContentDirectory(current)
        if (isRemoteDirectory(contentRoot)) return false
        return canEditDirectory(this.session, contentRoot, this.allDirectories, this.knowledgeAuth)
      },
      fetchKnowledgeAuth() {
        if (this.session && this.session.is_admin === true) {
          this.knowledgeAuth = normalizeKnowledgeAuth({
            roles: [PLATFORM_ADMIN_ROLE],
            groups: [],
          })
          this.knowledgeAuthLoaded = true
          return Promise.resolve()
        }
        return this.$api.get('/knowledge/auth').then((res) => {
          const data = (res.data && res.data.data) != null ? res.data.data : (res.data || {})
          this.knowledgeAuth = normalizeKnowledgeAuth(data)
        }).catch((err) => {
          this.knowledgeAuth = normalizeKnowledgeAuth()
          this.$Message.error('获取知识库身份失败: ' + err)
        }).finally(() => {
          this.knowledgeAuthLoaded = true
        })
      },
      findItemById(id) {
        return this.allItems.find(item => this.sameId(item.id, id));
      },
      isDirectoryId(id) {
        return this.allDirectories.some(dir => this.sameId(dir.id, id));
      },
      refreshItemsAfterMove(draggedId, targetDirId) {
        const stillVisible = this.selectedDir
          && this.getDirIdWithDescendants(this.selectedDir.id).some(dirId => this.sameId(dirId, targetDirId));
        if (stillVisible) {
          this.fetchItems();
          return;
        }
        this.allItems = this.allItems.map(item => (
          this.sameId(item.id, draggedId) ? {...item, dir_id: targetDirId} : item
        ));
        this.items = this.items.filter(item => !this.sameId(item.id, draggedId));
      },
      fetchDirectories(){
        this.loading = true
        return this.$api.get('/knowledge/directories').then(res=>{
          let dirs = res.data.data || []
          const focusId = this.focusDirId
          if (focusId) {
            const subtree = extractDirectorySubtree(dirs, focusId)
            if (!subtree.length) {
              this.$Message.warning('未找到指定目录或无权访问')
              dirs = []
            } else {
              dirs = subtree
            }
          }
          this.directories = dirs
          if (focusId && dirs.length) {
            const focused = this.findDirectoryInTree(dirs, focusId) || dirs[0]
            this.selectedDir = focused
          } else if (this.selectedDir) {
            const updated = this.findDirectoryInTree(this.directories, this.selectedDir.id)
              || this.allDirectories.find(dir => this.sameId(dir.id, this.selectedDir.id))
            if (updated) this.selectedDir = updated
          }
          if (this.showDirPermission && this.permissionForm.id) {
            const updatedPermDir = this.allDirectories.find(dir => this.sameId(dir.id, this.permissionForm.id))
            if (updatedPermDir) {
              this.permissionDir = updatedPermDir
              this.permissionForm = this.buildDirModalForm(updatedPermDir)
            }
          }
          this.loading = false
        }).catch(err=>{
          this.$Message.error('获取目录列表失败: ' + err)
          this.loading = false
        })
      },
      refreshRefDirectoryTreeIfNeeded() {
        if (!this.selectedDir) return Promise.resolve()
        let refRoot = null
        if (isRefDirectory(this.selectedDir)) {
          refRoot = this.findDirectoryInTree(this.directories, this.selectedDir.id) || this.selectedDir
        } else if (this.selectedDir._refDisplay) {
          refRoot = this.findRefRootForDisplayNode(this.selectedDir.id)
        }
        if (refRoot) {
          return this.loadRefDirectoryChildren(refRoot)
        }
        return Promise.resolve()
      },
      findRefRootForDisplayNode(dirId) {
        let found = null
        const walk = (nodes, refRoot) => {
          (nodes || []).some((node) => {
            const currentRefRoot = isRefDirectory(node) ? node : refRoot
            if (this.sameId(node.id, dirId)) {
              found = currentRefRoot
              return true
            }
            return walk(node.children || node.subs, currentRefRoot)
          })
        }
        walk(this.directories, null)
        return found
      },
      fetchItems(){
        this.loading = true
        this.$api.get('/knowledge/data').then(res=>{
          this.allItems = res.data.data || []
          this.items = this.allItems
          this.loading = false
        }).catch(err=>{
          this.$Message.error('获取内容列表失败: ' + err)
          this.loading = false
        })
      },
      getDirIdWithDescendants(dirId){
        const ids = [dirId]
        const children = (this.allDirectories || []).filter(d => this.sameId(d.parent_id, dirId))
        children.forEach(c => {
          const contentDir = this.resolveContentDirectory(c) || c
          if (!canViewDirectory(
            this.session,
            contentDir,
            this.allDirectories,
            this.knowledgeAuth,
          )) {
            return
          }
          ids.push(...this.getDirIdWithDescendants(c.id))
        })
        return ids
      },
      handleDirTreeExpandAll() {
        this.dirTreeExpandToken = {
          version: this.dirTreeExpandToken.version + 1,
          expanded: true,
        }
      },
      handleDirTreeCollapseAll() {
        this.dirTreeExpandToken = {
          version: this.dirTreeExpandToken.version + 1,
          expanded: false,
        }
      },
      handleDirSelect(dir){
        if (dir && !canViewDirectory(this.session, this.findDirectoryById(dir.id) || dir, this.allDirectories, this.knowledgeAuth)) {
          this.$Message.warning('无权查看该目录')
          return
        }
        if (dir && isRefDirectory(dir)) {
          this.loadRefDirectoryChildren(dir).finally(() => {
            this.selectedDir = this.findDirectoryInTree(this.directories, dir.id) || dir
          })
        } else {
          this.selectedDir = dir
        }
        this.selectedItems = []
      },
      handleRefDirectoryLoad(dir) {
        if (!dir || !isRefDirectory(dir)) return
        this.loadRefDirectoryChildren(dir)
      },
      handleDirPreview(dir) {
        if (!dir || dir.id == null) return
        this.RouteTo(`/core/documents/${dir.id}/view`, true)
      },
      handleDirConfig(dir){
        if (!dir) return
        this.openDirModal(dir)
      },
      fetchAclMeta() {
        this.$store.dispatch('session/getDeps')
        this.$store.dispatch('session/getUsers')
        this.$api.get('/admin/roles').then((res) => {
          this.aclRoles = res.data.data || []
        }).catch(() => {
          this.aclRoles = (this.session && this.session.roles) || []
        })
        this.$api.get('/admin/groups').then((res) => {
          this.aclGroups = res.data.data || []
        }).catch(() => {
          this.aclGroups = []
        })
      },
      handleConfigTypeChange(type) {
        this.applyDirTypeConstraints(this.permissionForm, type)
      },
      applyDirTypeConstraints(form, type) {
        const normalized = normalizeDirType(type)
        const prevRemoteApi = form.remote_api
        if (normalized === 'remote') {
          form.editable = false
          form.enable_upload = false
          if (prevRemoteApi && !String(prevRemoteApi).includes('://')) {
            form.remote_api = ''
          }
        } else if (normalized === 'ref') {
          if (prevRemoteApi && String(prevRemoteApi).includes('://')) {
            form.remote_api = ''
          }
        } else if (prevRemoteApi && !String(prevRemoteApi).includes('://')) {
          form.remote_api = ''
        }
        if (normalized !== 'dir') {
          form.data_type = 'raw'
        }
      },
      handlePermClientTypeChange() {
        this.permAddForm.client_id = ''
      },
      resetPermAddForm() {
        this.showPermAddForm = false
        this.permAddForm = EMPTY_PERM_ADD_FORM()
      },
      handleAddPermissionRow() {
        this.showPermAddForm = true
        this.permAddForm = EMPTY_PERM_ADD_FORM()
      },
      cancelPermAddForm() {
        this.resetPermAddForm()
      },
      confirmPermAddForm() {
        if (!this.permissionForm.id) return
        const { client_type, client_id, mod, effect } = this.permAddForm
        const normalizedId = client_id ? String(client_id) : ''
        if (!normalizedId) {
          this.$Message.warning('请选择授权对象')
          return
        }
        const duplicated = (this.permissionForm.permissions || []).some(item =>
          item.client_type === client_type
          && String(item.client_id) === normalizedId
          && item.mod === mod
        )
        if (duplicated) {
          this.$Message.warning('相同授权已存在')
          return
        }
        const payload = buildAclPayload(this.permissionForm.id, {
          client_type,
          client_id: normalizedId,
          mod,
          denied: effect === 'deny',
        })
        this.aclSaving = true
        this.$api.post('/knowledge/acls', payload).then(() => {
          this.$Message.success('授权已添加')
          this.resetPermAddForm()
          return this.fetchDirectories()
        }).catch(err => {
          this.$Message.error('添加授权失败: ' + err)
        }).finally(() => {
          this.aclSaving = false
        })
      },
      removePermissionRow(row) {
        if (!row || !row.id) {
          this.$Message.warning('无效的授权记录')
          return
        }
        this.aclSaving = true
        this.$api.delete(`/knowledge/acls/${row.id}`).then(() => {
          this.$Message.success('授权已删除')
          return this.fetchDirectories()
        }).catch(err => {
          this.$Message.error('删除授权失败: ' + err)
        }).finally(() => {
          this.aclSaving = false
        })
      },
      aclClientTypeLabel(type) {
        const map = { user: '用户', group: '群组', role: '角色' }
        return map[type] || type || '-'
      },
      aclClientTypeColor(type) {
        const map = { user: 'green', group: 'blue', role: 'gold' }
        return map[type] || 'default'
      },
      resolveAclClientName(row) {
        if (!row || !row.client_id) return '-'
        const id = String(row.client_id)
        if (row.client_type === 'group') {
          const group = this.aclGroupOptions.find(item => String(item.id) === id)
          return group ? group.name : id
        }
        if (row.client_type === 'role') {
          const role = (this.aclRoles || []).find(item => String(item.id) === id)
          return role ? role.name : id
        }
        const user = (this.users || []).find(item => String(item.id) === id)
        return user ? user.name : id
      },
      aclRowKey(row, index) {
        return `${row.id || row.client_type}-${row.client_id || index}-${row.mod || 'view'}`
      },
      handlePermissionSubmit(){
        if (this.dirModalReadOnly) return
        if (!this.permissionForm.name || !String(this.permissionForm.name).trim()) {
          this.$Message.warning('请输入目录名称')
          return
        }
        const type = normalizeDirType(this.permissionForm.type)
        let dataType = normalizeDirDataType(this.permissionForm.data_type)
        // 文档目录下新建/保存：强制为文档目录
        const parentDir = this.permissionForm.parent_id != null
          ? this.findDirectoryById(this.permissionForm.parent_id)
          : null
        if (type === 'dir' && isDocumentDirectory(parentDir, this.allDirectories)) {
          dataType = 'parsed'
        }
        if (type === 'remote' && !this.permissionForm.remote_api) {
          this.$Message.warning('远程目录请填写远程访问地址')
          return
        }
        if (type === 'ref' && !this.permissionForm.remote_api) {
          this.$Message.warning('请选择引用的目录')
          return
        }
        const payload = {
          name: String(this.permissionForm.name).trim(),
          type,
          is_shared: !!this.permissionForm.is_shared,
          is_private: !!this.permissionForm.is_private,
          editable: type === 'remote' ? false : this.permissionForm.editable !== false,
          enable_approval: !!this.permissionForm.enable_approval,
          enable_create_sub: this.permissionForm.enable_create_sub !== false,
          enable_upload: type === 'remote' ? false : this.permissionForm.enable_upload !== false,
          description: this.permissionForm.description || '',
          owner_id: this.permissionForm.owner_id || null,
          remote_api: (type === 'remote' || type === 'ref')
            ? String(this.permissionForm.remote_api || '')
            : '',
        }
        if (type === 'dir') {
          payload.data_type = dataType
        }
        if (!this.permissionForm.id && type === 'dir') {
          const creatable = getCreatableDirDataTypes(parentDir, this.allDirectories)
            .some((opt) => opt.value === dataType)
          if (!creatable) {
            this.$Message.warning('暂不支持新建该数据类型的目录')
            return
          }
        }
        if (this.permissionForm.id) {
          this.$api.patch(`/knowledge/directories/${this.permissionForm.id}`, payload).then(() => {
            this.$Message.success('保存成功')
            this.handleDirModalCancel()
            this.fetchDirectories().then(() => this.refreshRefDirectoryTreeIfNeeded())
          }).catch(err => {
            this.$Message.error('保存失败: ' + err)
          })
          return
        }
        payload.parent_id = this.permissionForm.parent_id
        this.$api.post('/knowledge/directories', payload).then(() => {
          this.$Message.success('创建成功')
          this.handleDirModalCancel()
          this.fetchDirectories().then(() => this.refreshRefDirectoryTreeIfNeeded())
        }).catch(err => {
          this.$Message.error('创建失败: ' + err)
        })
      },
      handleDirModalCancel() {
        this.showDirPermission = false
        this.permissionDir = null
        this.permissionRefDir = null
        this.permissionViewRefSource = false
        this.dirModalReadOnly = false
        this.permissionForm = EMPTY_PERMISSION_FORM()
        this.resetPermAddForm()
      },
      handleDirContextAction({ action, dir }){
        if(!dir) return
        const isSystem = isSystemDirectory(dir)
        const isRef = isRefDirectory(dir)
        const opDir = this.resolveOperationDirectory(dir)
        if(action === 'open-alone'){
          this.openDirectoryAlone(dir)
          return
        }
        if(action === 'open-as-doc'){
          this.openDirectoryAsDocument(dir)
          return
        }
        if(action === 'add'){
          if (opDir && opDir.enable_create_sub === false) {
            this.$Message.warning('该目录不允许创建子目录')
            return
          }
          const parentIsDoc = isDocumentDirectory(opDir || dir, this.allDirectories)
          this.selectedDir = dir
          this.openDirModal(null, {
            name: '',
            type: 'dir',
            data_type: parentIsDoc ? 'parsed' : 'raw',
            is_shared: false,
            is_private: true,
            parent_id: opDir ? opDir.id : dir.id,
          })
        } else if(action === 'edit'){
          if (isSystem) { this.$Message.warning('系统目录不可编辑属性'); return }
          this.selectedDir = dir
          this.openDirModal(dir)
        } else if(action === 'remove'){
          if (isSystem) { this.$Message.warning('系统目录不可删除'); return }
          this.$Modal.confirm({
            title: '确认删除',
            content: isRef
              ? `确定要删除引用目录"${dir.name}"吗？仅删除引用本身，不会影响源目录及文件。`
              : `确定要删除目录"${dir.name}"吗？`,
            onOk: () => {
              this.$api.delete(`/knowledge/directories/${dir.id}`).then(() => {
                this.$Message.success('删除成功')
                if(this.selectedDir && this.selectedDir.id === dir.id) this.selectedDir = null
                this.fetchDirectories()
              }).catch(err => this.$Message.error('删除失败: ' + err))
            }
          })
        }
      },
      buildToolsQuery(extra = {}) {
        const query = { ...extra }
        const uid = this.$route && this.$route.query && this.$route.query.uid
        if (uid) query.uid = uid
        return query
      },
      openQueryInNewTab(path, query) {
        const qs = Object.keys(query)
          .filter((k) => query[k] != null && query[k] !== '')
          .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(query[k])}`)
          .join('&')
        const url = `${window.location.origin}${path}${qs ? `?${qs}` : ''}`
        window.open(url, '_blank')
      },
      openDirectoryAlone(dir) {
        if (!dir || dir.id == null) return
        const uid = this.$route && this.$route.query && this.$route.query.uid
        if (uid) {
          this.openQueryInNewTab('/tools/knowledge-base', this.buildToolsQuery({ dir: String(dir.id) }))
          return
        }
        this.openQueryInNewTab('/core/knowledge/library', { dir: String(dir.id) })
      },
      openDirectoryAsDocument(dir) {
        if (!dir || dir.id == null) return
        const contentDir = this.resolveContentDirectory(dir) || dir
        this.openQueryInNewTab('/tools/documents', this.buildToolsQuery({ dir: String(contentDir.id) }))
      },
      handleItemContextMenu(payload){
        const { action, item, dir } = payload || {}
        if(action === 'open-alone' && dir){
          this.openDirectoryAlone(dir)
        } else if(action === 'open-as-doc' && dir){
          this.openDirectoryAsDocument(dir)
        } else if(action === 'generate-md' && item){
          this.handleGenerateMdFromItem(item)
        } else if(action === 'edit' && item){
          this.handleItemEdit(item)
        } else if(action === 'remove' && item){
          this.selectedItems = [item]
          this.handleDataToolbarEvent({ key: 'remove' })
        } else if(action === 'open' && item){
          this.handleItemOpen(item)
        }
      },
      resolveSourceKnowledgeItem(item) {
        if (!item) return null
        if (item.ref && item.content) {
          return this.allItems.find((i) => this.sameId(i.id, item.content)) || item
        }
        return item
      },
      getKnowledgeFileDisplayName(item) {
        const source = this.resolveSourceKnowledgeItem(item)
        if (!source) return '未命名文件'
        if (source.type === 'file' && source.content) {
          let fileName = decodeURIComponent((String(source.content).split('/').pop() || '').split('?')[0]) || ''
          const ext = getFileExtFromName(fileName || source.content)
          if (source.name && ext) return `${source.name}.${ext}`
          if (fileName) return fileName
        }
        return source.name || '未命名文件'
      },
      getMdTargetBaseName(item) {
        const source = this.resolveSourceKnowledgeItem(item)
        if (!source) return '未命名'
        // 优先用展示文件名去后缀，保证与源文件同名
        const display = this.getKnowledgeFileDisplayName(source)
        const fromDisplay = getFileBaseName(display)
        if (fromDisplay && fromDisplay !== '未命名') return fromDisplay
        if (source.name && String(source.name).trim()) {
          return getFileBaseName(source.name) || String(source.name).trim()
        }
        return '未命名'
      },
      findSameNameMdInDir(dirId, baseName, excludeId) {
        const target = String(baseName || '').trim().toLowerCase()
        if (!target || dirId == null) return null
        return (this.allItems || []).find((item) => {
          if (!item || item.type !== 'md') return false
          if (!this.sameId(item.dir_id, dirId)) return false
          if (excludeId != null && this.sameId(item.id, excludeId)) return false
          const rawName = String(item.name || '').trim()
          const name = getFileBaseName(rawName || '未命名').toLowerCase()
          return name === target || rawName.toLowerCase() === target
        }) || null
      },
      formatMineruApiError(err, fallback) {
        if (!err) return fallback || '未知错误'
        if (typeof err === 'string') return err
        const data = err.response && err.response.data
        const fromData = data && (data.message || data.error || data.detail || data.msg)
        if (fromData) return String(fromData)
        if (err.message) return String(err.message)
        return fallback || '未知错误'
      },
      async saveGeneratedMarkdown({ dirId, name, content, overwriteId }) {
        const payload = {
          type: 'md',
          name,
          content,
          dir_id: dirId,
        }
        if (overwriteId) {
          return this.$api.put(`/knowledge/data/${overwriteId}`, payload)
        }
        return this.$api.post('/knowledge/data', payload)
      },
      canGenerateMdItem(item) {
        const source = this.resolveSourceKnowledgeItem(item)
        if (!source || source.type !== 'file' || !source.content) return false
        if (isMdGenerateFileName(source.content)) return true
        if (source.name && ['pdf', 'doc', 'docx'].includes(getFileExtFromName(source.name))) return true
        return isMdGenerateFileName(this.getKnowledgeFileDisplayName(source))
      },
      handleGenerateMdFromItem(item) {
        if (!this.selectedDirEditable) {
          this.$Message.warning('当前目录为只读，无法生成 Markdown')
          return
        }
        const source = this.resolveSourceKnowledgeItem(item)
        if (!this.canGenerateMdItem(source)) {
          this.$Message.warning('仅支持 PDF / DOC / DOCX 生成 Markdown')
          return
        }
        const allowed = this.allowedContentTypes
        if (allowed.length && !allowed.includes('md')) {
          this.$Message.warning('当前目录数据类型不支持 Markdown')
          return
        }
        const dirId = source.dir_id != null ? source.dir_id : this.selectedContentDirId
        if (!dirId) {
          this.$Message.warning('请先选择目录')
          return
        }
        const baseName = this.getMdTargetBaseName(source)
        const existing = this.findSameNameMdInDir(dirId, baseName)
        if (existing) {
          this.mdConflict = {
            source,
            existing,
            dirId,
            baseName,
            sourceName: this.getKnowledgeFileDisplayName(source),
            targetName: existing.name || `${baseName}.md`,
          }
          this.mdConflictVisible = true
          return
        }
        this.enqueueMineruParseTask({
          source,
          dirId,
          baseName,
          overwriteId: null,
          saveAs: false,
        })
      },
      cancelMdConflict() {
        this.mdConflictVisible = false
        this.mdConflict = null
      },
      confirmMdConflict(mode) {
        const conflict = this.mdConflict
        if (!conflict || !conflict.source) {
          this.cancelMdConflict()
          return
        }
        const overwrite = mode === 'overwrite'
        this.mdConflictVisible = false
        this.enqueueMineruParseTask({
          source: conflict.source,
          dirId: conflict.dirId,
          baseName: conflict.baseName,
          existingName: conflict.existing && conflict.existing.name,
          overwriteId: overwrite ? conflict.existing.id : null,
          saveAs: !overwrite,
        })
        this.mdConflict = null
      },
      createMineruLocalTask(payload) {
        this.mineruTaskSeq += 1
        const localId = `mineru-${Date.now()}-${this.mineruTaskSeq}`
        const baseName = String(payload.baseName || '未命名').trim() || '未命名'
        const task = {
          localId,
          taskId: null,
          itemId: payload.source && payload.source.id,
          fileName: this.getKnowledgeFileDisplayName(payload.source),
          // 同名规则：默认与源文件同名；另存时加后缀
          targetName: payload.saveAs
            ? `${baseName}_解析`
            : (payload.existingName ? getFileBaseName(payload.existingName) || baseName : baseName),
          baseName,
          dirId: payload.dirId,
          overwriteId: payload.overwriteId || null,
          saveAs: !!payload.saveAs,
          sourceUrl: payload.source && payload.source.content,
          status: 'uploading',
          progress: 8,
          message: '准备提交解析任务…',
          queuedAhead: 0,
          error: '',
          saved: false,
          createdAt: Date.now(),
          updatedAt: Date.now(),
        }
        this.mineruTasks = [task, ...this.mineruTasks].slice(0, 30)
        this.persistMineruTasks()
        return task
      },
      persistMineruTasks() {
        saveMineruTasksToStorage(this.mineruTasks)
      },
      restoreMineruTasksFromStorage() {
        const stored = loadMineruTasksFromStorage()
        if (!stored.length) return
        this.mineruTasks = stored.map((task) => ({
          ...task,
          // 刷新后本地轮询中断，先展示为恢复中
          message: needsMineruTaskResume(task) && task.taskId
            ? (task.message || '页面已刷新，正在恢复任务…')
            : task.message,
        }))
        const maxSeq = stored.reduce((max, task) => {
          const m = String(task.localId || '').match(/mineru-\d+-(\d+)$/)
          const n = m ? Number(m[1]) : 0
          return Number.isFinite(n) ? Math.max(max, n) : max
        }, 0)
        this.mineruTaskSeq = Math.max(this.mineruTaskSeq || 0, maxSeq)
      },
      resumeMineruTasksAfterLogin() {
        const tasks = [...(this.mineruTasks || [])]
        tasks.forEach((task) => {
          if (!needsMineruTaskResume(task)) return
          if (task.taskId) {
            this.resumeMineruTaskById(task)
            return
          }
          // 刷新时还没拿到远端 taskId，无法续传上传请求
          if (isMineruTaskActive(task)) {
            this.patchMineruTask(task.localId, {
              status: 'error',
              progress: 100,
              message: '页面刷新时任务尚未提交成功，请重试',
              error: 'interrupted_before_submit',
            })
          }
        })
      },
      patchMineruTask(localId, patch) {
        const idx = this.mineruTasks.findIndex((t) => t.localId === localId)
        if (idx < 0) return
        const next = {
          ...this.mineruTasks[idx],
          ...patch,
          updatedAt: Date.now(),
        }
        this.$set(this.mineruTasks, idx, next)
        this.persistMineruTasks()
      },
      bindMineruAbortController(localId) {
        const controller = typeof AbortController !== 'undefined' ? new AbortController() : null
        if (!this.mineruAbortMap || typeof this.mineruAbortMap !== 'object') {
          this.mineruAbortMap = {}
        }
        if (controller) {
          this.$set(this.mineruAbortMap, localId, controller)
        }
        return controller
      },
      releaseMineruAbortController(localId) {
        if (this.mineruAbortMap && this.mineruAbortMap[localId]) {
          this.$delete(this.mineruAbortMap, localId)
        }
      },
      applyMineruProgress(localId, info) {
        const status = info.status || 'pending'
        const progress = estimateMineruTaskProgress(info)
        let message = info.message || ''
        if (info.phase === 'download') message = message || '正在下载源文件…'
        else if (info.phase === 'upload') message = message || '正在提交解析任务…'
        else if (status === 'pending') {
          message = info.queued_ahead > 0
            ? `排队中，前方还有 ${info.queued_ahead} 个任务`
            : (message || '排队等待解析…')
        } else if (status === 'processing') {
          message = message || '正在解析文档…'
        } else if (status === 'completed') {
          message = message || '解析完成，准备保存…'
        }
        const current = this.mineruTasks.find((t) => t.localId === localId)
        if (current && (current.status === 'error' || current.error === 'cancelled')) return
        const prev = (current && current.progress) || 0
        let nextProgress = Math.max(progress, 12)
        if (status === 'processing') {
          nextProgress = Math.min(88, Math.max(prev + 2, 42))
        }
        if (status === 'completed') nextProgress = Math.max(nextProgress, 90)
        this.patchMineruTask(localId, {
          taskId: info.task_id || (current && current.taskId) || null,
          status: ['uploading', 'pending', 'processing', 'completed'].includes(status)
            ? (status === 'completed' ? 'saving' : status)
            : (status || 'processing'),
          progress: nextProgress,
          message,
          queuedAhead: Number(info.queued_ahead) || 0,
        })
      },
      async finishMineruTaskWithMarkdown(task, mdContent) {
        if (!task) throw new Error('任务不存在')
        if (!mdContent) throw new Error('解析结果为空，未创建 Markdown 文件')

        const targetName = task.targetName || task.baseName || '未命名'
        this.patchMineruTask(task.localId, {
          status: 'saving',
          progress: 92,
          message: `正在创建同名 Markdown「${targetName}」…`,
        })

        const sourceUrl = resolveRemoteFileUrl(task.sourceUrl)
        const withLink = `${mdContent}\n\n---\n\n[查看原文](${sourceUrl})`

        // 刷新后可能同名文件已变化，保存前再查一次
        let overwriteId = task.overwriteId || null
        if (!overwriteId && !task.saveAs) {
          const existing = this.findSameNameMdInDir(task.dirId, task.baseName || targetName)
          if (existing) overwriteId = existing.id
        }

        try {
          await this.saveGeneratedMarkdown({
            dirId: task.dirId,
            name: targetName,
            content: withLink,
            overwriteId,
          })
        } catch (saveErr) {
          throw new Error(`解析成功，但保存 Markdown 失败：${this.formatMineruApiError(saveErr, '保存失败')}`)
        }

        if (task.itemId) {
          try {
            await this.$api.put(`/knowledge/data/${task.itemId}`, {
              has_markdown: true,
              markdown_content: withLink,
            })
          } catch (e) {
            // ignore
          }
        }

        this.patchMineruTask(task.localId, {
          status: 'completed',
          progress: 100,
          saved: true,
          overwriteId,
          message: overwriteId
            ? `已覆盖同名文件「${targetName}」`
            : `已创建同名 Markdown「${targetName}」`,
          queuedAhead: 0,
          error: '',
        })
        this.$Message.success(`已生成 Markdown：${targetName}`)
        this.fetchItems()
      },
      handleMineruTaskFailure(localId, err) {
        const msg = this.formatMineruApiError(err, '解析失败')
        const current = this.mineruTasks.find((t) => t.localId === localId)
        // 页面卸载触发的 abort：保留可恢复状态，不当作失败
        if (msg === '任务已取消') {
          if (current && current.error === 'cancelled') return
          if (current && current.taskId && !current.saved) {
            this.persistMineruTasks()
            return
          }
          this.patchMineruTask(localId, {
            status: 'error',
            progress: 100,
            message: '任务已取消',
            error: 'cancelled',
          })
          return
        }
        this.patchMineruTask(localId, {
          status: 'error',
          progress: 100,
          message: msg,
          error: msg,
        })
        this.$Message.error(`生成 MD 失败：${msg}`)
      },
      resumeMineruTaskById(task) {
        if (!task || !task.taskId || !task.localId) return
        if (this.mineruAbortMap && this.mineruAbortMap[task.localId]) return

        const controller = this.bindMineruAbortController(task.localId)
        this.patchMineruTask(task.localId, {
          status: task.saved ? 'completed' : 'processing',
          message: task.saved ? task.message : '页面已刷新，正在恢复离线解析任务…',
          progress: task.saved ? 100 : Math.max(task.progress || 20, 20),
        })

        const run = async () => {
          try {
            if (task.saved) return
            const result = await pollMineruTask(task.taskId, {
              signal: controller && controller.signal,
              onProgress: (info) => this.applyMineruProgress(task.localId, info),
            })
            const latest = this.mineruTasks.find((t) => t.localId === task.localId) || task
            if (latest.saved) return
            await this.finishMineruTaskWithMarkdown(latest, (result && result.md_content) || '')
          } catch (err) {
            this.handleMineruTaskFailure(task.localId, err)
          } finally {
            this.releaseMineruAbortController(task.localId)
          }
        }
        run()
      },
      enqueueMineruParseTask(payload) {
        const task = this.createMineruLocalTask(payload)
        const controller = this.bindMineruAbortController(task.localId)

        const run = async () => {
          try {
            this.patchMineruTask(task.localId, {
              status: 'uploading',
              progress: 10,
              message: '正在下载源文件并提交 MinerU 任务…',
            })
            const result = await parseRemoteFileToMarkdownViaTask(payload.source.content, {
              signal: controller && controller.signal,
              onProgress: (info) => this.applyMineruProgress(task.localId, info),
            })

            const latest = this.mineruTasks.find((t) => t.localId === task.localId) || task
            await this.finishMineruTaskWithMarkdown(latest, (result && result.md_content) || '')
          } catch (err) {
            this.handleMineruTaskFailure(task.localId, err)
          } finally {
            this.releaseMineruAbortController(task.localId)
          }
        }

        run().catch((err) => this.handleMineruTaskFailure(task.localId, err))
      },
      cancelMineruTask(task) {
        if (!task) return
        const controller = this.mineruAbortMap && this.mineruAbortMap[task.localId]
        if (controller) controller.abort()
        this.patchMineruTask(task.localId, {
          status: 'error',
          progress: 100,
          message: '任务已取消',
          error: 'cancelled',
        })
      },
      retryMineruTask(task) {
        if (!task || !task.sourceUrl) return
        // 若远端任务还在，优先续传取结果并自动保存
        if (task.taskId && !task.saved) {
          this.patchMineruTask(task.localId, {
            status: 'processing',
            progress: Math.max(task.progress || 20, 20),
            message: '正在重新连接离线任务…',
            error: '',
          })
          this.resumeMineruTaskById({
            ...task,
            saved: false,
            status: 'processing',
            error: '',
          })
          return
        }
        const source = this.allItems.find((i) => this.sameId(i.id, task.itemId))
          || { id: task.itemId, content: task.sourceUrl, type: 'file', dir_id: task.dirId, name: task.fileName }
        this.dismissMineruTask(task)
        this.enqueueMineruParseTask({
          source,
          dirId: task.dirId,
          baseName: task.baseName || (task.targetName && String(task.targetName).replace(/_解析$/, '')) || this.getMdTargetBaseName(source),
          overwriteId: task.overwriteId,
          saveAs: !!task.saveAs,
          existingName: task.saveAs ? null : task.targetName,
        })
      },
      dismissMineruTask(task) {
        if (!task) return
        const controller = this.mineruAbortMap && this.mineruAbortMap[task.localId]
        if (controller) controller.abort()
        this.releaseMineruAbortController(task.localId)
        this.mineruTasks = this.mineruTasks.filter((t) => t.localId !== task.localId)
        this.persistMineruTasks()
      },
      clearFinishedMineruTasks() {
        this.mineruTasks = this.mineruTasks.filter((t) => isMineruTaskActive(t))
        this.persistMineruTasks()
      },
      handleItemSelect(items){
        this.selectedItems = items
      },
      handleDirDropIn(data){
        const {draggedId, targetDirId} = data || {}
        if (!draggedId || !targetDirId || this.sameId(draggedId, targetDirId)) return
        if (!this.isDirectoryId(draggedId)) return

        const targetDir = this.findDirectoryById(targetDirId)
        if(targetDir && !this.isDirWritable(targetDir)){
          this.$Message.warning('该目录为只读，无法放入')
          return
        }
        const opTarget = this.resolveOperationDirectory(targetDir)
        const actualParentId = opTarget ? opTarget.id : targetDirId
        this.$api.put(`/knowledge/directories/${draggedId}`, {
          parent_id: actualParentId
        }).then(()=>{
          this.$Message.success('移动成功')
          this.fetchDirectories()
        }).catch(err=>{
          this.$Message.error('移动失败: ' + err)
        })
      },
      handleFileDropToDir(data){
        const {draggedId, targetDirId} = data || {}
        if (!draggedId || !targetDirId) return
        if (this.isDirectoryId(draggedId)) return

        const targetDir = this.findDirectoryById(targetDirId)
        const contentRoot = targetDir ? this.resolveContentDirectory(targetDir) : null
        const actualTargetId = contentRoot ? contentRoot.id : targetDirId
        if(targetDir && !this.isDirWritable(targetDir)){
          this.$Message.warning('该目录为只读，无法移动文件')
          return
        }
        const draggedItem = this.findItemById(draggedId)
        if(!draggedItem){
          this.$Message.warning('未找到要移动的内容')
          return
        }
        if (this.sameId(draggedItem.dir_id, actualTargetId)) return

        this.$api.put(`/knowledge/data/${draggedId}`, {
          dir_id: actualTargetId
        }).then(()=>{
          this.$Message.success('移动成功')
          this.refreshItemsAfterMove(draggedId, actualTargetId)
        }).catch(err=>{
          this.$Message.error('移动失败: ' + err)
        })
      },
      handleItemDropInFolder(data){
        const {draggedId, targetItemId} = data || {}
        const targetItem = this.findItemById(targetItemId)
        if(!targetItem || targetItem.dir_id == null){
          this.$Message.warning('无法移动到该位置')
          return
        }
        if (this.sameId(draggedId, targetItemId)) return
        this.handleFileDropToDir({
          draggedId,
          targetDirId: targetItem.dir_id,
        })
      },
      handleFileDrop(files){
        if(!files || files.length === 0) return
        if(!this.selectedDir){
          this.$Message.warning('请先选择目录')
          return
        }
        if(!this.isDirWritable(this.selectedDir)){
          this.$Message.warning('当前目录为只读，无法上传')
          return
        }
        if (!this.selectedDirUploadEnabled) {
          this.$Message.warning('该目录不允许上传或创建文件')
          return
        }
        const dirId = this.selectedContentDirId
        if (!dirId) {
          this.$Message.warning('请先选择目录')
          return
        }

        const allowed = this.allowedContentTypes
        const cosFiles = []
        const textEntries = []
        const skipped = []

        files.forEach((file) => {
          const itemType = resolveUploadItemType(file.name, allowed)
          if (!itemType) {
            skipped.push(file.name)
            return
          }
          if (itemType === 'file') cosFiles.push(file)
          else textEntries.push({ file, itemType })
        })

        if (skipped.length > 0) {
          const preview = skipped.slice(0, 3).join('、')
          const suffix = skipped.length > 3 ? '…' : ''
          this.$Message.warning(`部分文件类型不允许：${preview}${suffix}`)
        }
        if (cosFiles.length === 0 && textEntries.length === 0) return

        const createRecords = async () => {
          const promises = []

          for (const { file, itemType } of textEntries) {
            const content = await this.readFileAsText(file)
            const name = (file.name || '').replace(/\.[^/.]+$/, '') || '未命名'
            promises.push(this.$api.post('/knowledge/data', {
              type: itemType,
              content,
              dir_id: dirId,
              name,
            }))
          }

          if (cosFiles.length > 0) {
            const coskey = this.$store.getters['session/session'] && this.$store.getters['session/session'].coskey
            if (!coskey) {
              this.$Message.warning('未配置上传，无法上传文件类型内容')
              if (textEntries.length === 0) return
            } else {
              await new Promise((resolve, reject) => {
                this.$cos.upload(cosFiles, {
                  onSuccess: (uploaded) => {
                    (uploaded || []).forEach((f) => {
                      const name = (f.name || '').replace(/\.[^/.]+$/, '') || '未命名'
                      promises.push(this.$api.post('/knowledge/data', {
                        type: 'file',
                        content: f.url,
                        dir_id: dirId,
                        name: name || undefined,
                      }))
                    })
                    resolve()
                  },
                  onFail: (err) => reject(err),
                }, { coskey })
              })
            }
          }

          if (promises.length === 0) return
          await Promise.all(promises)
          this.$Message.success(`成功上传 ${promises.length} 个文件`)
          this.fetchItems()
        }

        createRecords().catch((err) => {
          this.$Message.error('上传失败: ' + err)
        })
      },
      readFileAsText(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onload = () => resolve(reader.result || '')
          reader.onerror = () => reject(reader.error || new Error('读取文件失败'))
          reader.readAsText(file)
        })
      },
      handleDataFileInputChange(e) {
        const files = Array.from(e.target.files || [])
        if (files.length > 0) this.handleFileDrop(files)
        e.target.value = ''
      },
      getDecomposeItemTitle(item) {
        return getItemDisplayTitle(item, this.allItems)
      },
      getDecomposeItemTypeLabel(item) {
        const map = { md: 'MD', text: 'TXT', file: 'FILE', html: 'HTML' }
        const source = item.ref && item.content
          ? (this.allItems.find((i) => String(i.id) === String(item.content)) || item)
          : item
        return map[source.type] || 'FILE'
      },
      openDecomposeModal() {
        if (!this.canCreateFiles) {
          this.$Message.warning('该目录不允许上传或创建文件')
          return
        }
        const allowed = this.allowedContentTypes
        if (!allowed.includes('md')) {
          this.$Message.warning('当前目录数据类型不支持 Markdown，无法保存拆解结果')
          return
        }
        this.decomposeStep = 'select'
        this.decomposePreviewGroups = []
        this.decomposeProgress = ''
        const preselected = (this.selectedItems || [])
          .filter((item) => isDecomposableItem(item, this.allItems))
          .map((item) => String(item.id))
        if (preselected.length) {
          this.decomposeSelectedIds = preselected
        } else {
          this.decomposeSelectedIds = this.decomposableItemsInDir.map((item) => String(item.id))
        }
        this.decomposeModalVisible = true
      },
      closeDecomposeModal() {
        if (this.decomposeSaving) return
        this.decomposeModalVisible = false
        this.decomposeStep = 'select'
        this.decomposeSelectedIds = []
        this.decomposePreviewGroups = []
        this.decomposeProgress = ''
      },
      toggleDecomposeSelectAll() {
        const all = this.decomposableItemsInDir.map((item) => String(item.id))
        if (this.decomposeSelectAll) {
          this.decomposeSelectedIds = []
        } else {
          this.decomposeSelectedIds = all.slice()
        }
      },
      resolveDecomposeSourceItem(item) {
        if (item.ref && item.content) {
          return this.allItems.find((i) => String(i.id) === String(item.content)) || item
        }
        return item
      },
      async callAiDecompose(prompt) {
        const res = await this.$api.post('ai/completions', {
          prompt,
          model: 'hunyuan',
          type: 'chat',
          json: true,
          stream: false,
        }, { timeout: 300000 })
        const text = extractAiCompletionText(res)
        if (!text || !String(text).trim()) {
          throw new Error('AI 未返回有效内容')
        }
        return text
      },
      async startDecompose() {
        if (!this.decomposeSelectedIds.length) {
          this.$Message.warning('请至少选择一项内容')
          return
        }
        const items = this.decomposeSelectedIds
          .map((id) => this.allItems.find((item) => String(item.id) === String(id)))
          .filter(Boolean)

        const blocked = items.filter((item) => !isDecomposableItem(item, this.allItems))
        if (blocked.length) {
          const names = blocked.map((item) => this.getDecomposeItemTitle(item)).join('、')
          this.$Message.warning(`以下内容无法拆解：${names}`)
          return
        }

        this.decomposeStep = 'analyzing'
        this.decomposePreviewGroups = []
        const groups = []

        try {
          for (let i = 0; i < items.length; i += 1) {
            const item = items[i]
            const source = this.resolveDecomposeSourceItem(item)
            const title = getItemDisplayTitle(item, this.allItems)
            this.decomposeProgress = `正在拆解 ${i + 1} / ${items.length}：${title}`
            const text = resolveItemTextForDecompose(item, this.allItems)
            const prompt = buildDecomposePrompt(title, text)
            const raw = await this.callAiDecompose(prompt)
            const points = parseDecomposeResult(raw)
            if (!points.length) {
              throw new Error(`「${title}」拆解结果为空，请重试`)
            }
            groups.push({
              sourceId: String(source.id),
              sourceName: title,
              sourceItem: source,
              splitGroup: newSplitGroupId(),
              points,
            })
          }
          this.decomposePreviewGroups = groups
          this.decomposeStep = 'preview'
          this.decomposeProgress = ''
        } catch (err) {
          this.decomposeStep = 'select'
          this.decomposeProgress = ''
          this.$Message.error(`拆解失败：${err.message || err}`)
        }
      },
      async confirmDecomposeSave() {
        if (!this.canCreateFiles) {
          this.$Message.warning('该目录不允许上传或创建文件')
          return
        }
        const dirId = this.selectedContentDirId
        if (!dirId) {
          this.$Message.warning('请先选择目录')
          return
        }
        const toSave = []
        this.decomposePreviewGroups.forEach((group) => {
          const selectedPoints = (group.points || []).filter((p) => p.selected)
          const total = selectedPoints.length
          const siblingTitles = selectedPoints.map((p) => p.title)
          selectedPoints.forEach((point, index) => {
            const others = siblingTitles.filter((_, i) => i !== index)
            const md = buildKnowledgePointMd(point, {
              sourceId: group.sourceId,
              sourceName: group.sourceName,
              splitGroup: group.splitGroup,
              splitIndex: index + 1,
              splitTotal: total,
              siblingTitles: others,
            })
            toSave.push({
              type: 'md',
              name: point.title,
              content: md,
              markdown_content: md,
              has_markdown: true,
              dir_id: dirId,
              source_id: group.sourceId,
              split_group: group.splitGroup,
              split_index: index + 1,
            })
          })
        })

        if (!toSave.length) {
          this.$Message.warning('请至少保留一个知识点')
          return
        }

        this.decomposeSaving = true
        try {
          await Promise.all(toSave.map((payload) => this.$api.post('/knowledge/data', payload)))
          this.$Message.success(`已保存 ${toSave.length} 个知识点文件`)
          this.closeDecomposeModal()
          this.fetchItems()
        } catch (err) {
          this.$Message.error(`保存失败：${err.message || err}`)
        } finally {
          this.decomposeSaving = false
        }
      },
      handleDirectoryToolbarEvent(e){
        const {key} = e
        if(key === 'add'){
          const opDir = this.selectedDir ? this.resolveOperationDirectory(this.selectedDir) : null
          if (opDir && opDir.enable_create_sub === false) {
            this.$Message.warning('该目录不允许创建子目录')
            return
          }
          const parentIsDoc = isDocumentDirectory(opDir || this.selectedDir, this.allDirectories)
          this.openDirModal(null, {
            name:'',
            type:'dir',
            data_type: parentIsDoc ? 'parsed' : 'raw',
            is_shared:false,
            is_private:true,
            parent_id: opDir ? opDir.id : (this.selectedDir ? this.selectedDir.id : null),
          })
        }else if(key === 'edit'){
          if(!this.selectedDir) return
          if (isSystemDirectory(this.selectedDir)) {
            this.$Message.warning('系统目录不可编辑属性')
            return
          }
          this.openDirModal(this.selectedDir)
        }else if(key === 'remove'){
          if(!this.selectedDir) return
          const isRef = isRefDirectory(this.selectedDir)
          this.$Modal.confirm({
            title:'确认删除',
            content: isRef
              ? `确定要删除引用目录"${this.selectedDir.name}"吗？仅删除引用本身，不会影响源目录及文件。`
              : `确定要删除目录"${this.selectedDir.name}"吗？`,
            onOk:()=>{
              this.$api.delete(`/knowledge/directories/${this.selectedDir.id}`).then(()=>{
                this.$Message.success('删除成功')
                this.selectedDir = null
                this.fetchDirectories()
              }).catch(err=>{
                this.$Message.error('删除失败: ' + err)
              })
            }
          })
        }
      },
      handleDataToolbarEvent(e){
        const {key,type,value} = e
        if(key === 'upload'){
          if (!this.canCreateFiles || !this.canUploadFiles) return
          const input = this.$refs.dataFileInput
          if (input) input.click()
        }else if(key === 'decompose'){
          this.openDecomposeModal()
        }else if(key === 'add'){
          if (!this.canCreateFiles) {
            this.$Message.warning('该目录不允许上传或创建文件')
            return
          }
          this.editorTab = 'basic';
          const allowed = this.allowedContentTypes.length
            ? this.allowedContentTypes
            : ['text']
          const editorTypes = ['text', 'md', 'html', 'file']
          const preferred = editorTypes.find(t => allowed.includes(t)) || allowed[0] || 'text'
          this.itemForm = {
            type: preferred,
            content:'',
            dir_id: this.selectedContentDirId || '',
            name:'',
            markdown_content:'',
            has_markdown: false,
          };
          this.showItemEditor = true
        }else if(key === 'edit'){
          if(this.selectedItems.length !== 1) return
          const item = this.selectedItems[0]
          this.fillItemForm(item)
          this.showItemEditor = true
        }else if(key === 'remove'){
          if(this.selectedItems.length === 0) return
          this.$Modal.confirm({
            title:'确认删除',
            content:`确定要删除选中的${this.selectedItems.length}个项目吗？`,
            onOk:()=>{
              const promises = this.selectedItems.map(item => 
                this.$api.delete(`/knowledge/data/${item.id}`)
              )
              Promise.all(promises).then(()=>{
                this.$Message.success('删除成功')
                this.selectedItems = []
                this.fetchItems()
              }).catch(err=>{
                this.$Message.error('删除失败: ' + err)
              })
            }
          })
        }else if(type == 'tab-change'){
          this.toolBarValue.toolBarValue.view_mode = value
        }else if(key === 'mirror'){
          if(this.selectedItems.length === 0) return
          // 检查是否都是引用类型，引用类型不能镜像
          if(this.selectedItems.some(item => item.ref)){
            this.$Message.warning('引用类型不能创建镜像')
            return
          }
          // 直接在当前选中的目录创建镜像，如果没有选中目录则使用原文件的目录
          const targetDirId = this.selectedContentDirId
            || (this.selectedItems[0] ? this.selectedItems[0].dir_id : null)
          
          if(!targetDirId){
            this.$Message.warning('请先选择目录')
            return
          }
          
          // 为每个选中的项目创建引用数据，保持原类型和名称，设置ref为true
          const promises = this.selectedItems.map(item => {
            // 获取源文件（如果是引用文件，需要找到真正的源文件）
            const sourceItem = item.ref && item.content ? this.allItems.find(i => i.id === item.content) : item
            return this.$api.post('/knowledge/data', {
              type: sourceItem.type, // 保持原类型
              content: sourceItem.id, // 引用原始内容的ID
              dir_id: targetDirId,
              ref: true // 标记为引用
            })
          })
          
          Promise.all(promises).then(()=>{
            this.$Message.success(`成功创建 ${this.selectedItems.length} 个镜像`)
            this.fetchItems()
          }).catch(err=>{
            this.$Message.error('创建镜像失败: ' + err)
          })
        }
      },
      handleItemSubmit(){
        if(!this.itemForm.type){
          this.$Message.warning('请选择类型')
          return
        }
        if (!this.itemForm.id && !this.selectedDirUploadEnabled) {
          this.$Message.warning('该目录不允许上传或创建文件')
          return
        }
        if (this.selectedDir) {
          const dir = this.resolveOperationDirectory(this.selectedDir)
          const allowed = getAllowedContentTypes(dir, this.allDirectories)
          if (!allowed.includes(this.itemForm.type)) {
            this.$Message.warning('当前目录数据类型不支持该内容类型')
            return
          }
        }
        if(this.itemForm.type === 'file' && !this.itemForm.content){
          this.$Message.warning('请上传文件')
          return
        }
        if(this.itemForm.type !== 'file' && !this.itemForm.content){
          this.$Message.warning('请输入内容')
          return
        }
        const url = this.itemForm.id 
          ? `/knowledge/data/${this.itemForm.id}`
          : '/knowledge/data'
        const method = this.itemForm.id ? 'put' : 'post'
        const payload = {
          ...this.itemForm,
          dir_id: this.itemForm.dir_id || null,
          markdown_content: this.itemForm.markdown_content,
          has_markdown: this.itemForm.has_markdown,
        };
        this.$api[method](url, payload).then(()=>{
          this.$Message.success('保存成功')
          this.showItemEditor = false
          this.fetchItems()
        }).catch(err=>{
          this.$Message.error('保存失败: ' + err)
        })
      },
      handleItemCancel(){
        this.showItemEditor = false
        this.itemForm = {
          type:'text',
          content:'',
          dir_id:'',
          name:'',
          markdown_content:'',
          has_markdown: false,
        };
        this.editorTab = 'basic';
      },
      handleItemTypeChange(){
        this.itemForm.content = ''
      },
      handleFileUpload(file){
        // 自动获取文件名称
        const fileName = file.name || ''
        if(!this.itemForm.name && fileName){
          // 去掉扩展名作为默认名称
          const nameWithoutExt = fileName.substring(0, fileName.lastIndexOf('.')) || fileName
          this.itemForm.name = nameWithoutExt
        }
        
        this.$cos.upload([file], {
          onSuccess: (files) => {
            if(files && files.length > 0){
              this.itemForm.content = files[0].url
              // 如果还没有设置名称，使用文件名
              if(!this.itemForm.name && fileName){
                const nameWithoutExt = fileName.substring(0, fileName.lastIndexOf('.')) || fileName
                this.itemForm.name = nameWithoutExt
              }
              this.$Message.success('文件上传成功')
            }
          },
          onFail: (err) => {
            this.$Message.error('文件上传失败: ' + err)
          }
        }, {
          coskey: this.$store.getters['session/session'].coskey
        })
        return false
      },
      handleItemOpen(item){
        this.current = item
        this.showDetail = true
      },
      fillItemForm(item) {
        this.editorTab = 'basic';
        this.itemForm = {
          id: item.id,
          type: item.type,
          content: item.content || '',
          dir_id: item.dir_id != null ? item.dir_id : '',
          name: item.name || '',
          markdown_content: item.markdown_content || '',
          has_markdown: !!(item.has_markdown || item.markdown_content),
          audit_status: item.audit_status,
          rag_status: item.rag_status,
        };
      },
      handleItemEdit(item){
        this.fillItemForm(item);
        this.showItemEditor = true;
      },
      handleItemMarkdown(item) {
        this.fillItemForm(item);
        this.editorTab = 'markdown';
        this.showItemEditor = true;
      },
      async handleParseMarkdown() {
        const sourceUrl = this.itemForm.content;
        if (!sourceUrl) {
          this.$Message.warning('请先上传文件');
          return;
        }
        if (!isParseableFileName(sourceUrl)) {
          this.$Message.warning('当前文件类型不支持解析，仅支持 PDF、Word 及图片');
          return;
        }

        this.markdownParsing = true;
        try {
          const mdContent = await parseRemoteFileToMarkdown(sourceUrl);
          const sourceLink = `\n\n---\n\n[查看原文](${sourceUrl})`;
          this.itemForm.markdown_content = mdContent ? `${mdContent}${sourceLink}` : `[查看原文](${sourceUrl})`;
          this.itemForm.has_markdown = true;
          this.$Message.success('Markdown 解析完成');
        } catch (err) {
          this.$Message.error(`解析失败：${err.message || err}`);
        } finally {
          this.markdownParsing = false;
        }
      },
      handleSearch(){
        // 搜索逻辑已在computed中处理
      },
      handleToolbarInput(value){
        this.toolBarValue = value
        // 视图切换时更新 viewMode
        if(value && value.toolBarValue && value.toolBarValue.view_mode){
          // viewMode 会通过 computed 自动更新
        }
      },
      getItemIcon(item){
        // 如果是文件类型，根据文件扩展名返回不同图标
        if(item.type === 'file' && item.content){
          const url = item.content
          const fileName = url.split('/').pop() || ''
          const ext = fileName.split('.').pop().toLowerCase()
          return this.getFileIconByExt(ext)
        }
        
        // 其他类型使用固定图标
        const iconMap = {
          text: 'md-document',
          md: 'logo-markdown',
          html: 'css',
          ref: 'lianjie',
        }
        return iconMap[item.type] || 'wenjian'
      },
      getFileIconByExt(ext){
        const extIconMap = {
          'txt': 'md-document-text',
          'doc': 'md-document',
          'docx': 'md-document',
          'pdf': 'md-document',
          'xls': 'md-document',
          'xlsx': 'md-document',
          'ppt': 'md-document',
          'pptx': 'md-document',
          'js': 'codelibrary-fill',
          'ts': 'codelibrary-fill',
          'jsx': 'codelibrary-fill',
          'tsx': 'codelibrary-fill',
          'vue': 'codelibrary-fill',
          'py': 'codelibrary-fill',
          'java': 'codelibrary-fill',
          'cpp': 'codelibrary-fill',
          'c': 'codelibrary-fill',
          'go': 'codelibrary-fill',
          'php': 'codelibrary-fill',
          'rb': 'codelibrary-fill',
          'md': 'logo-markdown',
          'markdown': 'logo-markdown',
          'html': 'css',
          'htm': 'css',
          'xml': 'css',
          'json': 'codelibrary-fill',
          'yaml': 'codelibrary-fill',
          'yml': 'codelibrary-fill',
          'jpg': 'images',
          'jpeg': 'images',
          'png': 'images',
          'gif': 'images',
          'svg': 'images',
          'webp': 'images',
          'bmp': 'images',
          'zip': 'wenjian',
          'rar': 'wenjian',
          '7z': 'wenjian',
          'tar': 'wenjian',
          'gz': 'wenjian',
          'mp4': 'shipin',
          'avi': 'shipin',
          'mov': 'shipin',
          'mp3': 'shipin',
          'wav': 'shipin',
        }
        return extIconMap[ext] || 'wenjian'
      },
      getItemName(item){
        if(item.type === 'file' && item.content){
          const url = item.content
          const fileName = url.split('/').pop() || '未命名文件'
          return fileName
        }
        if(item.type === 'text' || item.type === 'md' || item.type === 'html'){
          const content = item.content || ''
          const firstLine = content.split('\n')[0] || '未命名文档'
          return firstLine.substring(0, 30) + (firstLine.length > 30 ? '...' : '')
        }
        return '未命名'
      },
    }
}
</script>

<style lang="less" scoped>
.knowledge-page {
  height: 100%;
  min-height: 0;
  background: var(--bg2);
  position: relative;
}

.knowledge-view-switch-bar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px 0;
}

.knowledge-view-switch {
  display: inline-flex;
  padding: 3px;
  border-radius: 999px;
  background: var(--bg3);
  border: 1px solid var(--border);
}

.knowledge-view-switch-btn {
  border: none;
  background: transparent;
  color: var(--subtext2);
  padding: 6px 18px;
  border-radius: 999px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s;
  line-height: 1;

  &:hover {
    color: var(--text);
  }

  &.active {
    background: #fff;
    color: var(--primary);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    font-weight: 600;
  }
}

.md-conflict-desc {
  margin: 10px 0 0;
  font-size: 13px;
  color: var(--subtext2);
  line-height: 1.5;
}

.markdown-parse-panel {
  padding: 4px 0;
}

/deep/ .knowledge-item-editor-drawer {
  .ivu-drawer-content {
    overflow: hidden;
  }

  .ivu-drawer-body {
    height: 100%;
    padding: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
}

.item-editor-shell {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.item-editor-header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 20px 12px;
  border-bottom: 1px solid var(--border);
  background: linear-gradient(180deg, var(--bg3) 0%, var(--bg2) 100%);
}

.item-editor-header-left {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.item-editor-mode {
  font-size: 16px;
  font-weight: 600;
  color: var(--text);
}

.item-editor-subtitle {
  font-size: 12px;
  color: var(--subtext2);
}

.item-editor-nav {
  display: inline-flex;
  padding: 3px;
  border-radius: 8px;
  background: var(--bg3);
  border: 1px solid var(--border);
  flex-shrink: 0;
}

.item-editor-nav-btn {
  border: none;
  background: transparent;
  color: var(--subtext2);
  padding: 6px 14px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s;

  &.active {
    background: #fff;
    color: var(--primary);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  }
}

.item-editor-body {
  flex: 1;
  min-height: 0;
  padding: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.item-editor-body--basic {
  .item-editor-layout {
    flex: 1;
    min-height: 0;
  }
}

.item-editor-body--markdown {
  gap: 12px;
}

.item-editor-markdown-toolbar {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.item-editor-layout {
  display: flex;
  gap: 20px;
  align-items: stretch;
  min-height: 0;
}

.item-editor-sidebar {
  width: 220px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.sidebar-section {
  padding: 14px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--bg3);
}

.sidebar-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--subtext2);
  margin-bottom: 10px;
}

.item-editor-main {
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.editor-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 0;

  &--static {
    flex-shrink: 0;
  }

  &--scroll,
  &--fill {
    flex: 1;
    min-height: 0;
  }
}

.editor-scroll-panel {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: #fff;
}

.editor-field-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--text);
}

.editor-title-input /deep/ .ivu-input {
  font-size: 16px;
  font-weight: 500;
}

.editor-textarea /deep/ .ivu-input {
  min-height: 320px;
  font-family: Consolas, Monaco, 'Courier New', monospace;
  line-height: 1.6;
}

.editor-textarea--fill {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;

  /deep/ .ivu-input-wrapper {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }

  /deep/ .ivu-input {
    flex: 1;
    min-height: 0;
    height: 100% !important;
    resize: none;
    border: none;
    border-radius: 10px;
    padding: 16px;
    overflow: auto;
  }
}

.editor-content-panel {
  border: 1px solid var(--border);
  border-radius: 10px;
  overflow: hidden;
  background: #fff;

  &--fill {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }
}

.editor-upload-card {
  padding: 16px;
  border: 1px dashed var(--border);
  border-radius: 10px;
  background: var(--bg3);
}

.editor-file-preview {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid var(--border);
  word-break: break-all;
}

.editor-file-empty {
  margin-top: 12px;
  color: var(--subtext3);
  font-size: 13px;
}

.markdown-parse-tip {
  margin-bottom: 0;
}

.markdown-parse-meta,
.editor-source-link {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.markdown-parse-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--subtext2);
}

.item-editor-footer {
  flex-shrink: 0;
  margin-top: 0;
}

.knowledge-modal-content {
  padding: 20px;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}

.knowledge-modal-footer {
  padding: 15px 20px;
  border-top: 1px solid var(--border);
  display: flex;
  justify-content: flex-end;
  background: var(--bg3);
}

.markdown-editor-wrapper {
  position: relative;
  z-index: 1;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;

  /deep/ .markdown-editor-wrap {
    flex: 1;
    min-height: 0;
  }

  /deep/ .v-note-wrapper {
    min-height: 0;
    z-index: 1;
    border: none;
    box-shadow: none;
  }

  /deep/ .v-note-toolbar {
    z-index: 1000 !important;
    position: relative;
    flex-shrink: 0;
  }

  /deep/ .v-note-edit,
  /deep/ .v-show-content {
    min-height: 0;
  }
}

.html-editor-wrapper {
  position: relative;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;

  /deep/ .tox-tinymce {
    flex: 1;
    min-height: 0;
    border: none;
  }

  /deep/ .tox-edit-area {
    min-height: 0;
  }
}

.type-selector {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.type-selector-vertical {
  flex-direction: column;
  gap: 8px;
}

.type-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px 20px;
  border: 2px solid var(--border);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  min-width: 100px;
  background: var(--bg3);
  
  &:hover {
    border-color: var(--primary);
    background: var(--primary-light);
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  &.active {
    border-color: var(--primary);
    background: var(--primary);
    color: #fff;
    box-shadow: 0 4px 12px rgba(51, 153, 255, 0.3);
  }
  
  span {
    margin-top: 8px;
    font-size: 14px;
    font-weight: 500;
  }
}

.type-selector-vertical .type-option {
  flex-direction: row;
  justify-content: flex-start;
  min-width: 0;
  width: 100%;
  padding: 10px 12px;

  span {
    margin-top: 0;
    margin-left: 10px;
    font-size: 13px;
  }

  &:hover {
    transform: none;
  }
}

.knowledge-left-panel {
  background: #fff;
  border-right: 1px solid var(--border);
}

.directory-panel-search {
  flex-shrink: 0;
  padding: 8px 10px 6px;
  border-bottom: 1px solid var(--border);
  background: var(--bg3);

  .directory-search-input {
    margin-bottom: 8px;
  }

  .directory-view-filters {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
  }

  .directory-view-filter-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    min-width: 28px;
    height: 28px;
    padding: 0 8px;
    border: 1px solid var(--border);
    border-radius: 6px;
    background: #fff;
    color: var(--subtext2);
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      color: var(--primary);
      border-color: var(--primary);
    }

    &.active {
      color: var(--primary);
      border-color: var(--primary);
      background: var(--primary-light);
      font-weight: 600;
    }
  }

  .directory-view-filter-short {
    font-size: 12px;
    line-height: 1;
  }
}

.directory-panel-header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px;
  border-bottom: 1px solid var(--border);
  min-height: 40px;
  .directory-panel-title {
    font-weight: 600;
    font-size: 14px;
    color: var(--text);
  }
  .directory-panel-toolbar {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-left: auto;
  }
  .directory-config-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    padding: 0;
    border: 1px solid var(--border);
    border-radius: 6px;
    background: var(--bg3);
    color: var(--subtext2);
    cursor: pointer;
    transition: all 0.2s;
    flex-shrink: 0;

    &:hover {
      color: var(--primary);
      border-color: var(--primary);
      background: var(--primary-light);
    }
  }
}

/deep/ .knowledge-dir-config-modal {
  .ivu-modal-body {
    padding: 0;
  }
  .ivu-modal-header {
    padding: 0;
    border-bottom: none;
  }
}

.dir-config-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px 12px;
  border-bottom: 1px solid var(--border);
  background: linear-gradient(180deg, var(--bg3) 0%, var(--bg2) 100%);
}

.dir-config-header-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--primary-light);
  color: var(--primary);
  flex-shrink: 0;
}

.dir-config-header-main {
  min-width: 0;
}

.dir-config-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--text);
}

.dir-config-subtitle {
  margin-top: 2px;
  font-size: 12px;
  color: var(--subtext2);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dir-config-body {
  padding: 12px 16px;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}

.dir-config-section + .dir-config-section {
  margin-top: 12px;
}

.dir-config-section-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
}

.dir-config-section-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--text);
}

.dir-config-section-desc {
  margin-top: 4px;
  font-size: 12px;
  color: var(--subtext3);
}

.dir-config-card {
  padding: 14px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--bg3);

  &--compact {
    padding: 10px 12px;
  }
}

.dir-config-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
}

.dir-config-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--text);
}

.dir-config-readonly-value {
  padding: 8px 12px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: var(--bg2);
  color: var(--text);
  font-size: 13px;
  line-height: 1.4;

  &--with-icon {
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }
}

.dir-config-readonly-icon {
  flex-shrink: 0;
}

.dir-config-access-vis {
  margin-bottom: 10px;
}

.dir-config-add-perm-btn {
  flex-shrink: 0;
}

.dir-config-switch-grid {
  display: flex;
  flex-direction: column;
  gap: 8px;

  &--compact {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    margin-top: 4px;
  }
}

.dir-config-field-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 14px;
}

.dir-config-remote-tip {
  margin-top: 8px;
  margin-bottom: 0;
}

.dir-type-btn-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.dir-type-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s;
  margin: 0 !important;
  min-height: 36px;

  &:hover {
    border-color: var(--primary);
    background: var(--primary-light);
  }

  /deep/ .ivu-radio {
    display: none;
  }

  /deep/ &.ivu-radio-wrapper-checked {
    border-color: var(--primary);
    background: var(--primary-light);
    color: var(--primary);
    box-shadow: inset 0 0 0 1px var(--primary);
    font-weight: 600;
  }
}

.dir-data-type-btn-group {
  .dir-data-type-btn {
    flex: 1;
    min-width: 120px;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
  }
}

.dir-config-switch-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 6px;
  background: #fff;
  border: 1px solid var(--border);

  /deep/ .ivu-switch {
    flex-shrink: 0;
  }
}

.dir-config-switch-meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.dir-config-switch-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--text);
}

.dir-config-switch-desc {
  font-size: 12px;
  color: var(--subtext3);
}

.dir-config-perm-add {
  margin-bottom: 12px;
  padding: 12px;
  border: 1px dashed var(--border);
  border-radius: 10px;
  background: var(--bg3);
}

.dir-config-perm-add-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.dir-config-perm-add-row + .dir-config-perm-add-row {
  margin-top: 10px;
}

.dir-config-perm-flags {
  justify-content: space-between;
}

.dir-config-perm-add-actions {
  margin-left: auto;
  display: flex;
  gap: 8px;
}

.dir-config-perm-all-tip {
  flex: 1;
  min-width: 160px;
  padding: 0 10px;
  line-height: 32px;
  color: var(--subtext2);
  font-size: 13px;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 4px;
}

.dir-config-perm-table-wrap {
  border: 1px solid var(--border);
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

.dir-config-perm-table {
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 10px 12px;
    border-bottom: 1px solid var(--border);
    text-align: left;
    font-size: 13px;
  }

  th {
    background: var(--bg3);
    color: var(--subtext2);
    font-weight: 600;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }

  .perm-mod-col,
  .perm-effect-col {
    width: 88px;
    text-align: center;
  }

  .perm-action-col {
    width: 72px;
    text-align: center;
  }
}

.perm-remove-btn {
  color: var(--error) !important;
}

.dir-config-perm-empty {
  padding: 28px 16px;
  text-align: center;
  color: var(--subtext3);
  font-size: 13px;
}

.dir-config-footer {
  margin-top: 0;
}

.knowledge-client {
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.knowledge-main-row {
  flex: 1;
  display: flex;
  width:100%;
  min-height: 0;
  min-width: 0;
}

.knowledge-status-bar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  font-size: 12px;
  color: var(--subtext2);
  background: var(--bg3);
  border-top: 1px solid var(--border);
  width: 100%;
  .status-path {
    flex: 1;
    overflow: hidden;
    margin-right: 12px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 2px;
  }
  .status-path-item {
    display: inline-flex;
    align-items: center;
  }
  .status-path-sep {
    display: inline-flex;
    align-items: center;
    margin: 0 4px;
    color: var(--subtext3);
  }
  .status-path-link {
    cursor: pointer;
    color: var(--subtext2);
  }
  .status-path-link:hover {
    color: var(--primary);
  }
  .status-meta {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
  }
  .status-count,
  .status-usage {
    color: var(--subtext3);
  }
  .status-dir-meta {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    padding-left: 12px;
    border-left: 1px solid var(--border);
  }
  .status-dir-meta-item {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
  }
  .status-dir-meta-label {
    color: var(--subtext3);
    font-size: 12px;
  }
  .status-dir-meta-value {
    color: var(--text);
    font-size: 12px;
    font-weight: 500;
  }
  .status-charger {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding-left: 12px;
    border-left: 1px solid var(--border);
  }
  .status-charger-label {
    color: var(--subtext3);
    font-size: 12px;
    white-space: nowrap;
  }
  .status-role {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding-left: 12px;
    border-left: 1px solid var(--border);
    margin-left: 4px;
  }
  .status-role-label {
    color: var(--subtext3);
    font-size: 12px;
    white-space: nowrap;
  }
  .status-role-value {
    color: var(--primary);
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
  }
}

.data-panel-header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding: 6px 12px;
  border-bottom: 1px solid var(--border);
  gap: 12px;
  .data-search-input {
    width: 200px;
    flex-shrink: 0;
  }
  .data-panel-toolbar {
    flex: 1;
    min-width: 0;
    display: flex;
    justify-content: flex-end;
    /deep/ .u-toolbar {
      margin-left: auto;
    }
  }
}

/deep/ .knowledge-detail-drawer {
  .ivu-drawer-content {
    overflow: hidden;
  }

  .ivu-drawer-body {
    height: 100%;
    padding: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
}

.dir-data-type-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.dir-data-type-label {
  font-weight: 600;
  font-size: 13px;
}

.dir-data-type-desc {
  font-size: 11px;
  color: var(--subtext3);
  line-height: 1.3;
}

.decompose-step {
  min-height: 200px;
  max-height: 60vh;
  overflow: auto;
}

.decompose-tip {
  margin-bottom: 12px;
}

.decompose-empty {
  padding: 32px 16px;
  text-align: center;
  color: var(--subtext3);
}

.decompose-select-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.decompose-select-all {
  padding-bottom: 8px;
  border-bottom: 1px solid var(--border);
}

.decompose-checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.decompose-select-item {
  padding: 6px 8px;
  border-radius: 6px;
  &:hover {
    background: var(--bg3);
  }
}

.decompose-item-title {
  margin-right: 8px;
}

.decompose-item-type {
  vertical-align: middle;
}

.decompose-step--analyzing {
  position: relative;
  min-height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.decompose-analyzing-text {
  text-align: center;
  z-index: 1;
  p {
    margin-top: 12px;
    color: var(--text2);
  }
}

.decompose-progress {
  font-size: 12px;
  color: var(--subtext3);
}

.decompose-preview-groups {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.decompose-preview-group {
  border: 1px solid var(--border);
  border-radius: 8px;
  overflow: hidden;
}

.decompose-group-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  background: var(--bg3);
  border-bottom: 1px solid var(--border);
}

.decompose-group-title {
  font-weight: 600;
  font-size: 13px;
}

.decompose-preview-point {
  display: flex;
  gap: 10px;
  padding: 10px 12px;
  border-bottom: 1px solid var(--border);
  &:last-child {
    border-bottom: none;
  }
}

.decompose-point-check {
  flex-shrink: 0;
  margin-top: 4px;
}

.decompose-point-body {
  flex: 1;
  min-width: 0;
}

.decompose-point-title-input {
  margin-bottom: 6px;
}

.decompose-point-summary {
  margin: 0 0 6px;
  font-size: 12px;
  color: var(--subtext2);
}

.decompose-point-content {
  margin: 0;
  padding: 8px;
  background: var(--bg2);
  border-radius: 4px;
  font-size: 12px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 120px;
  overflow: auto;
}

.decompose-point-quote {
  margin: 6px 0 0;
  font-size: 12px;
  color: var(--subtext3);
  font-style: italic;
}

</style>